// import React, { useEffect, useState, useRef } from "react";
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   Grid,
//   Chip,
//   Button,
//   Divider,
//   TextField,
//   Avatar,
//   IconButton,
//   BottomNavigation,
//   BottomNavigationAction,
//   Paper,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   FormControl,
//   Select,
//   MenuItem,
//   InputLabel,
//   Slide,
//   Badge,
//   Stack,
//   Tooltip,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Moped,
//   Storefront,
//   AccountBalanceWallet,
//   Person,
//   Call,
//   Navigation,
//   Close,
//   VolumeUp,
//   TouchApp,
//   CheckCircle,
//   LocationOn,
//   Schedule,
//   Phone,
//   QrCode2,
//   ContentCopy,
//   CameraAlt,
//   Refresh,
//   Payment,
//   LocalDining,
//   Receipt,
//   Warning,
//   Logout as LogoutIcon,
//   Home,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import io from "socket.io-client";
// import axiosInstance from "../../utils/axios";
// import { toast } from "react-toastify";

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// const BRAND = {
//   primary: "#FF6B00",
//   primaryDark: "#E85A00",
//   gradient: "linear-gradient(135deg, #FF6B00 0%, #E85A00 100%)",
// };

// const PAGE_LIMIT = 20;

// // 📅 Date/time formatters
// const formatOrderDateTime = (dateStr) => {
//   if (!dateStr) return "";
//   const date = new Date(dateStr);
//   if (isNaN(date.getTime())) return "";
//   const now = new Date();
//   const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//   const orderDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
//   const diffDays = Math.floor((today - orderDay) / (1000 * 60 * 60 * 24));
//   const time = date.toLocaleTimeString("en-IN", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//     timeZone: "Asia/Kolkata",
//   });
//   if (diffDays === 0) return `Today, ${time}`;
//   if (diffDays === 1) return `Yesterday, ${time}`;
//   const day = date.toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     timeZone: "Asia/Kolkata",
//   });
//   return `${day}, ${time}`;
// };

// const formatFullDateTime = (dateStr) => {
//   if (!dateStr) return "";
//   const date = new Date(dateStr);
//   if (isNaN(date.getTime())) return "";
//   return date.toLocaleString("en-IN", {
//     weekday: "long",
//     day: "numeric",
//     month: "long",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//     timeZone: "Asia/Kolkata",
//   });
// };

// // 🔗 UPI helpers
// const generateUPILink = (upiId, name, amount = "") => {
//   if (!upiId) return "";
//   const params = new URLSearchParams({
//     pa: upiId,
//     pn: name || "Restaurant",
//     cu: "INR",
//   });
//   if (amount) params.append("am", amount);
//   return `upi://pay?${params.toString()}`;
// };

// const generateQRUrl = (data, size = 300) =>
//   `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(
//     data
//   )}&bgcolor=FFFFFF&color=1e293b&margin=8`;

// const getPhonePeUPI = (number) => {
//   if (!number) return null;
//   const str = String(number).trim();
//   if (str.includes("@")) return str;
//   return `${str}@ybl`;
// };

// // 🎨 Status configs
// const ORDER_STATUS_CFG = {
//   PENDING:          { color: "#f59e0b", bg: "#fef3c7", label: "Pending" },
//   ACCEPTED:         { color: "#8b5cf6", bg: "#ede9fe", label: "Accepted" },
//   PREPARING:        { color: "#f59e0b", bg: "#fef3c7", label: "Preparing" },
//   OUT_FOR_DELIVERY: { color: "#3b82f6", bg: "#dbeafe", label: "Out for Delivery" },
//   DELIVERED:        { color: "#10b981", bg: "#d1fae5", label: "Delivered" },
//   CANCELLED:        { color: "#ef4444", bg: "#fee2e2", label: "Cancelled" },
// };

// const COD_STATUS_CFG = {
//   UNSETTLED:    { color: "#dc2626", bg: "#fee2e2", label: "To Deposit",  icon: <Warning fontSize="small" /> },
//   REJECTED:     { color: "#dc2626", bg: "#fee2e2", label: "Rejected",    icon: <Warning fontSize="small" /> },
//   UNDER_REVIEW: { color: "#d97706", bg: "#fef3c7", label: "In Review",   icon: <Schedule fontSize="small" /> },
//   PAID:         { color: "#059669", bg: "#d1fae5", label: "Paid",        icon: <CheckCircle fontSize="small" /> },
// };

// export default function DeliveryDashboard() {
//   const navigate = useNavigate();
//   const [navTab, setNavTab] = useState(0);
//   const [orderFilter, setOrderFilter] = useState("AVAILABLE");
//   const [profile, setProfile] = useState({});
//   const [orders, setOrders] = useState([]);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [detailsOpen, setDetailsOpen] = useState(false);
//   const [socketConnected, setSocketConnected] = useState(false);
//   const [refreshing, setRefreshing] = useState(false);
//   const socketRef = useRef(null);

//   // 📄 Orders pagination
//   const [ordersPage, setOrdersPage] = useState(1);
//   const [ordersHasMore, setOrdersHasMore] = useState(true);
//   const [ordersLoading, setOrdersLoading] = useState(false);
//   const [ordersInitialLoading, setOrdersInitialLoading] = useState(true);
//   const [counts, setCounts] = useState({ AVAILABLE: 0, MY_ORDERS: 0, DELIVERED: 0 });

//   // 🏨 Restaurants pagination
//   const [restaurants, setRestaurants] = useState([]);
//   const [restPage, setRestPage] = useState(1);
//   const [restHasMore, setRestHasMore] = useState(true);
//   const [restLoading, setRestLoading] = useState(false);
//   const [restInitialLoading, setRestInitialLoading] = useState(true);

//   // 💰 COD orders (separate fetch for earnings tab)
//   const [codOrders, setCodOrders] = useState([]);

//   // Refs for socket closures
//   const orderFilterRef = useRef(orderFilter);
//   useEffect(() => { orderFilterRef.current = orderFilter; }, [orderFilter]);

//   // Infinite scroll sentinels
//   const ordersLoadMoreRef = useRef(null);
//   const restLoadMoreRef = useRef(null);

//   const [qrDialog, setQrDialog] = useState({ open: false, type: null, restaurant: null });

//   const [profileForm, setProfileForm] = useState({
//     name: "", phone: "", address: "", vehicleType: "Bike", vehicleNumber: "",
//   });
//   const [newProfileImage, setNewProfileImage] = useState(null);
//   const [passwordForm, setPasswordForm] = useState({ currentPassword: "", newPassword: "" });
//   const [savingProfile, setSavingProfile] = useState(false);

//   const playNotificationSound = () => {
//     try {
//       const audio = new Audio("/sounds/notification.mp3");
//       audio.play().catch(() => {});
//     } catch (e) {}
//   };

//   // ══════════════════════════════════════════════════════
//   // FETCHERS
//   // ══════════════════════════════════════════════════════
//   const fetchProfile = async () => {
//     try {
//       const res = await axiosInstance.get("/api/delivery/profile");
//       const user = res.data.deliveryBoy;
//       setProfile(user);
//       setProfileForm({
//         name: user.name || "",
//         phone: user.phone || "",
//         address: user.address || "",
//         vehicleType: user.vehicleType || "Bike",
//         vehicleNumber: user.vehicleNumber || "",
//       });
//     } catch (err) {
//       if (err.response?.status === 401) navigate("/delivery/login");
//     }
//   };

//   const fetchOrders = async (type, pageNum, append = false) => {
//     if (append) setOrdersLoading(true);
//     else setOrdersInitialLoading(true);
//     try {
//       const res = await axiosInstance.get("/api/delivery/orders", {
//         params: { page: pageNum, limit: PAGE_LIMIT, type },
//       });
//       const items = res.data.orders || [];
//       setOrders((prev) => (append ? [...prev, ...items] : items));
//       setOrdersHasMore(res.data.pagination?.hasNextPage ?? false);
//     } catch (err) {
//       if (err.response?.status === 401) navigate("/delivery/login");
//     } finally {
//       setOrdersLoading(false);
//       setOrdersInitialLoading(false);
//     }
//   };

//   const fetchCounts = async () => {
//     try {
//       const [a, b, c] = await Promise.all([
//         axiosInstance.get("/api/delivery/orders", { params: { type: "AVAILABLE", limit: 1 } }),
//         axiosInstance.get("/api/delivery/orders", { params: { type: "MY_ORDERS", limit: 1 } }),
//         axiosInstance.get("/api/delivery/orders", { params: { type: "DELIVERED", limit: 1 } }),
//       ]);
//       setCounts({
//         AVAILABLE: a.data.pagination?.total || 0,
//         MY_ORDERS: b.data.pagination?.total || 0,
//         DELIVERED: c.data.pagination?.total || 0,
//       });
//     } catch (err) {}
//   };

//   const fetchRestaurants = async (pageNum, append = false) => {
//     if (append) setRestLoading(true);
//     else setRestInitialLoading(true);
//     try {
//       const res = await axiosInstance.get("/api/delivery/restaurants", {
//         params: { page: pageNum, limit: PAGE_LIMIT },
//       });
//       const items = res.data.restaurants || [];
//       setRestaurants((prev) => (append ? [...prev, ...items] : items));
//       setRestHasMore(res.data.pagination?.hasNextPage ?? false);
//     } catch (err) {
//     } finally {
//       setRestLoading(false);
//       setRestInitialLoading(false);
//     }
//   };

//   const fetchCodOrders = async () => {
//     try {
//       // Fetch all delivered orders for earnings tab (up to 100)
//       const res = await axiosInstance.get("/api/delivery/orders", {
//         params: { type: "DELIVERED", limit: 100 },
//       });
//       setCodOrders(res.data.orders || []);
//     } catch (err) {}
//   };

//   const fetchAll = async () => {
//     await Promise.all([
//       fetchProfile(),
//       fetchRestaurants(1, false),
//       fetchOrders(orderFilter, 1, false),
//       fetchCounts(),
//       fetchCodOrders(),
//     ]);
//   };

//   const handleManualRefresh = async () => {
//     setRefreshing(true);
//     await fetchAll();
//     setRefreshing(false);
//     toast.success("Data refreshed");
//   };

//   // ══════════════════════════════════════════════════════
//   // MOUNT + SOCKET
//   // ══════════════════════════════════════════════════════
//   useEffect(() => {
//     fetchAll();

//     const baseURL = axiosInstance.defaults.baseURL || "http://localhost:8000";
//     const socket = io(baseURL.replace(/\/$/, ""), {
//       withCredentials: true,
//       transports: ["websocket", "polling"],
//       reconnection: true,
//     });
//     socketRef.current = socket;

//     socket.on("connect", () => {
//       setSocketConnected(true);
//       const deliveryUser = JSON.parse(localStorage.getItem("deliveryUser") || "{}");
//       if (deliveryUser.city) {
//         socket.emit("delivery-join", {
//           deliveryBoyId: deliveryUser._id || deliveryUser.id,
//           city: deliveryUser.city,
//           name: deliveryUser.name,
//         });
//       }
//     });

//     socket.on("disconnect", () => setSocketConnected(false));

//     socket.on("delivery-new-order", (data) => {
//       playNotificationSound();
//       toast.info(`🔔 New Order from ${data.order?.restaurant?.restaurantName || "Hotel"}!`);
//       if (orderFilterRef.current === "AVAILABLE") {
//         setOrders((prev) => [data.order, ...prev.filter((o) => o._id !== data.order._id)]);
//       }
//       setCounts((prev) => ({ ...prev, AVAILABLE: prev.AVAILABLE + 1 }));
//     });

//     socket.on("order-claimed-by-rider", ({ orderId, claimedBy }) => {
//       const myId = profile._id;
//       if (claimedBy !== myId) {
//         setOrders((prev) => prev.filter((o) => o._id !== orderId));
//         if (selectedOrder?._id === orderId) {
//           setDetailsOpen(false);
//           setSelectedOrder(null);
//           toast.info("This order was accepted by another rider.");
//         }
//         setCounts((prev) => ({ ...prev, AVAILABLE: Math.max(0, prev.AVAILABLE - 1) }));
//       }
//     });

//     socket.on("delivery-order-updated", (data) => {
//       setOrders((prev) =>
//         prev.map((o) => (o._id === data.order._id ? { ...o, status: data.order.status } : o))
//       );
//       if (selectedOrder?._id === data.order._id) {
//         setSelectedOrder((prev) => ({ ...prev, status: data.order.status }));
//       }
//     });

//     socket.on("cod-settlement-updated", ({ order: updatedOrder, message, status }) => {
//       if (message) {
//         status === "PAID" ? toast.success(message) : toast.error(message);
//       }
//       setOrders((prev) =>
//         prev.map((o) => (o._id === updatedOrder._id ? updatedOrder : o))
//       );
//       setCodOrders((prev) =>
//         prev.map((o) => (o._id === updatedOrder._id ? updatedOrder : o))
//       );
//     });

//     return () => socket.disconnect();
//     // eslint-disable-next-line
//   }, [profile._id, selectedOrder]);

//   // ══════════════════════════════════════════════════════
//   // FILTER CHANGE — reset & fetch
//   // ══════════════════════════════════════════════════════
//   useEffect(() => {
//     setOrdersPage(1);
//     setOrders([]);
//     setOrdersHasMore(true);
//     fetchOrders(orderFilter, 1, false);
//   }, [orderFilter]);

//   // ══════════════════════════════════════════════════════
//   // INFINITE SCROLL — ORDERS
//   // ══════════════════════════════════════════════════════
//   useEffect(() => {
//     if (navTab !== 0) return;
//     const el = ordersLoadMoreRef.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (
//           entries[0].isIntersecting &&
//           ordersHasMore &&
//           !ordersLoading &&
//           !ordersInitialLoading
//         ) {
//           const nextPage = ordersPage + 1;
//           setOrdersPage(nextPage);
//           fetchOrders(orderFilter, nextPage, true);
//         }
//       },
//       { threshold: 0.1, rootMargin: "200px" }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, [ordersHasMore, ordersLoading, ordersInitialLoading, ordersPage, orderFilter, navTab]);

//   // ══════════════════════════════════════════════════════
//   // INFINITE SCROLL — RESTAURANTS
//   // ══════════════════════════════════════════════════════
//   useEffect(() => {
//     if (navTab !== 1) return;
//     const el = restLoadMoreRef.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (
//           entries[0].isIntersecting &&
//           restHasMore &&
//           !restLoading &&
//           !restInitialLoading
//         ) {
//           const nextPage = restPage + 1;
//           setRestPage(nextPage);
//           fetchRestaurants(nextPage, true);
//         }
//       },
//       { threshold: 0.1, rootMargin: "200px" }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, [restHasMore, restLoading, restInitialLoading, restPage, navTab]);

//   // ══════════════════════════════════════════════════════
//   // ACTIONS
//   // ══════════════════════════════════════════════════════
//   const handleAcceptOrder = async (orderId, e) => {
//     if (e) e.stopPropagation();
//     try {
//       const res = await axiosInstance.put(`/api/delivery/orders/${orderId}/accept`);
//       toast.success("Order Accepted! Assigned to you.");
//       setCounts((prev) => ({
//         ...prev,
//         AVAILABLE: Math.max(0, prev.AVAILABLE - 1),
//         MY_ORDERS: prev.MY_ORDERS + 1,
//       }));
//       if (selectedOrder?._id === orderId) setSelectedOrder(res.data.order);
//       setOrderFilter("MY_ORDERS");
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to accept order");
//       fetchCounts();
//     }
//   };

//   const handleUpdateStatus = async (orderId, newStatus) => {
//     try {
//       const res = await axiosInstance.put(`/api/delivery/orders/${orderId}/status`, {
//         status: newStatus,
//       });
//       toast.success(`Order status: ${newStatus}`);
//       const updated = res.data.order;
//       if (selectedOrder?._id === orderId) setSelectedOrder(updated);

//       if (orderFilter === "MY_ORDERS" && newStatus === "DELIVERED") {
//         setOrders((prev) => prev.filter((o) => o._id !== orderId));
//         setCounts((prev) => ({
//           ...prev,
//           MY_ORDERS: Math.max(0, prev.MY_ORDERS - 1),
//           DELIVERED: prev.DELIVERED + 1,
//         }));
//         if (updated.paymentMethod === "CASH") {
//           setCodOrders((prev) => [updated, ...prev]);
//         }
//       } else {
//         setOrders((prev) => prev.map((o) => (o._id === orderId ? updated : o)));
//         setCodOrders((prev) => prev.map((o) => (o._id === orderId ? updated : o)));
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to update status");
//     }
//   };

//   const handlePayToRestaurant = async (orderId) => {
//     try {
//       const res = await axiosInstance.put(`/api/delivery/orders/${orderId}/pay-to-restaurant`);
//       toast.info("Request sent! Status is now Under Review.");
//       setOrders((prev) => prev.map((o) => (o._id === orderId ? res.data.order : o)));
//       setCodOrders((prev) => prev.map((o) => (o._id === orderId ? res.data.order : o)));
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to send request");
//     }
//   };

//   const handleSaveProfile = async (e) => {
//     e.preventDefault();
//     setSavingProfile(true);
//     try {
//       const data = new FormData();
//       Object.keys(profileForm).forEach((key) => data.append(key, profileForm[key]));
//       if (newProfileImage) data.append("profileImage", newProfileImage);
//       const res = await axiosInstance.put("/api/delivery/profile/update", data, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       setProfile(res.data.deliveryBoy);
//       setNewProfileImage(null);
//       toast.success("Profile updated successfully!");
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to update profile");
//     } finally {
//       setSavingProfile(false);
//     }
//   };

//   const handleChangePassword = async (e) => {
//     e.preventDefault();
//     try {
//       await axiosInstance.put("/api/delivery/profile/password", passwordForm);
//       toast.success("Password changed successfully!");
//       setPasswordForm({ currentPassword: "", newPassword: "" });
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Password change failed");
//     }
//   };

//   const handleLogout = () => {
//     if (socketRef.current) socketRef.current.disconnect();
//     localStorage.removeItem("deliveryUser");
//     navigate("/delivery/login");
//   };

//   // Derived
//   const myId = profile._id;
//   const myCodOrders = codOrders.filter((o) => o.paymentMethod === "CASH");
//   const pendingCodAmount = myCodOrders
//     .filter((o) => !o.codSettlement?.status || ["UNSETTLED", "REJECTED"].includes(o.codSettlement?.status))
//     .reduce((sum, o) => sum + (o.orderSummary?.totalAmount || 0), 0);
//   const underReviewCodAmount = myCodOrders
//     .filter((o) => o.codSettlement?.status === "UNDER_REVIEW")
//     .reduce((sum, o) => sum + (o.orderSummary?.totalAmount || 0), 0);
//   const settledCodAmount = myCodOrders
//     .filter((o) => o.codSettlement?.status === "PAID")
//     .reduce((sum, o) => sum + (o.orderSummary?.totalAmount || 0), 0);

//   // QR helpers
//   const openQRDialog = (restaurant, type) => setQrDialog({ open: true, type, restaurant });
//   const closeQRDialog = () => setQrDialog({ open: false, type: null, restaurant: null });
//   const getActiveUpiId = () => {
//     if (!qrDialog.restaurant) return "";
//     if (qrDialog.type === "UPI") return qrDialog.restaurant.payment?.upiId;
//     return getPhonePeUpiSafe(qrDialog.restaurant.payment?.phonePeNumber);
//   };
//   const getPhonePeUpiSafe = (n) => getPhonePeUPI(n);
//   const handleCopyUpi = async () => {
//     const id = getActiveUpiId();
//     if (!id) return;
//     try {
//       await navigator.clipboard.writeText(id);
//       toast.success("UPI ID copied!");
//     } catch {
//       toast.error("Copy failed");
//     }
//   };

//   return (
//     <Box sx={{ maxWidth: 550, mx: "auto", minHeight: "100vh", bgcolor: "#f8fafc", pb: 10 }}>
//       {/* ══════════════ HEADER ══════════════ */}
//       <Box
//         sx={{
//           bgcolor: "#fff",
//           px: 2,
//           py: 1.75,
//           position: "sticky",
//           top: 0,
//           zIndex: 100,
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
//           borderBottom: "1px solid #f1f5f9",
//         }}
//       >
//         <Box display="flex" alignItems="center" gap={1.5} minWidth={0} flex={1}>
//           <Box position="relative">
//             <Avatar
//               src={profile.profileImage?.url}
//               alt={profile.name}
//               sx={{
//                 width: 46,
//                 height: 46,
//                 border: `2px solid ${BRAND.primary}`,
//                 fontSize: 18,
//                 fontWeight: 700,
//               }}
//             >
//               {profile.name?.[0]?.toUpperCase()}
//             </Avatar>
//             <Box
//               sx={{
//                 position: "absolute",
//                 bottom: 0,
//                 right: 0,
//                 width: 13,
//                 height: 13,
//                 borderRadius: "50%",
//                 bgcolor: socketConnected ? "#10b981" : "#94a3b8",
//                 border: "2px solid #fff",
//                 boxShadow: socketConnected ? "0 0 0 3px rgba(16,185,129,0.25)" : "none",
//               }}
//             />
//           </Box>
//           <Box minWidth={0} flex={1}>
//             <Typography variant="subtitle1" fontWeight={700} lineHeight={1.15} noWrap sx={{ fontSize: 15 }}>
//               {profile.name || "Delivery Partner"}
//             </Typography>
//             <Box display="flex" alignItems="center" gap={0.75} mt={0.4}>
//               <Chip
//                 icon={<LocationOn sx={{ fontSize: "12px !important", color: `${BRAND.primaryDark} !important` }} />}
//                 label={profile.city?.toUpperCase() || "N/A"}
//                 size="small"
//                 sx={{
//                   height: 20,
//                   fontSize: 10,
//                   bgcolor: "#FFF4EC",
//                   color: BRAND.primaryDark,
//                   fontWeight: 700,
//                   "& .MuiChip-label": { px: 0.75 },
//                 }}
//               />
//               <Typography variant="caption" sx={{ color: "#94a3b8", fontSize: 10 }}>
//                 {socketConnected ? "Live" : "Offline"}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         <Box display="flex" gap={0.75} alignItems="center">
//           <Tooltip title="Refresh">
//             <IconButton
//               size="small"
//               onClick={handleManualRefresh}
//               disabled={refreshing}
//               sx={{ bgcolor: "#f8fafc", color: "#64748b", "&:hover": { bgcolor: "#f1f5f9" } }}
//             >
//               <Refresh
//                 fontSize="small"
//                 sx={{ animation: refreshing ? "spin 1s linear infinite" : "none", "@keyframes spin": { "100%": { transform: "rotate(360deg)" } } }}
//               />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Test sound">
//             <IconButton
//               size="small"
//               onClick={playNotificationSound}
//               sx={{ bgcolor: "#f8fafc", color: "#64748b", "&:hover": { bgcolor: "#f1f5f9" } }}
//             >
//               <VolumeUp fontSize="small" />
//             </IconButton>
//           </Tooltip>
//           <Button
//             size="small"
//             startIcon={<LogoutIcon sx={{ fontSize: 16 }} />}
//             onClick={handleLogout}
//             sx={{
//               color: "#dc2626",
//               fontSize: 12,
//               fontWeight: 700,
//               textTransform: "none",
//               minWidth: "auto",
//               px: 1.25,
//               py: 0.5,
//               borderRadius: 2,
//               "&:hover": { bgcolor: "#fee2e2" },
//             }}
//           >
//             Logout
//           </Button>
//         </Box>
//       </Box>

//       {/* ══════════════ TAB 0: ORDERS ══════════════ */}
//       {navTab === 0 && (
//         <Box p={2}>
//           <Box display="flex" gap={1} mb={2} overflow="auto" sx={{ "&::-webkit-scrollbar": { display: "none" } }}>
//             <Chip
//               label={`New (${counts.AVAILABLE})`}
//               onClick={() => setOrderFilter("AVAILABLE")}
//               sx={{
//                 fontWeight: 700, fontSize: 12, height: 32,
//                 bgcolor: orderFilter === "AVAILABLE" ? BRAND.primary : "#fff",
//                 color: orderFilter === "AVAILABLE" ? "#fff" : "#64748b",
//                 border: "1px solid", borderColor: orderFilter === "AVAILABLE" ? BRAND.primary : "#e2e8f0",
//                 "&:hover": { bgcolor: orderFilter === "AVAILABLE" ? BRAND.primaryDark : "#f8fafc" },
//               }}
//             />
//             <Chip
//               label={`Active (${counts.MY_ORDERS})`}
//               onClick={() => setOrderFilter("MY_ORDERS")}
//               sx={{
//                 fontWeight: 700, fontSize: 12, height: 32,
//                 bgcolor: orderFilter === "MY_ORDERS" ? "#f59e0b" : "#fff",
//                 color: orderFilter === "MY_ORDERS" ? "#fff" : "#64748b",
//                 border: "1px solid", borderColor: orderFilter === "MY_ORDERS" ? "#f59e0b" : "#e2e8f0",
//                 "&:hover": { bgcolor: orderFilter === "MY_ORDERS" ? "#d97706" : "#f8fafc" },
//               }}
//             />
//             <Chip
//               label={`Delivered (${counts.DELIVERED})`}
//               onClick={() => setOrderFilter("DELIVERED")}
//               sx={{
//                 fontWeight: 700, fontSize: 12, height: 32,
//                 bgcolor: orderFilter === "DELIVERED" ? "#10b981" : "#fff",
//                 color: orderFilter === "DELIVERED" ? "#fff" : "#64748b",
//                 border: "1px solid", borderColor: orderFilter === "DELIVERED" ? "#10b981" : "#e2e8f0",
//                 "&:hover": { bgcolor: orderFilter === "DELIVERED" ? "#059669" : "#f8fafc" },
//               }}
//             />
//           </Box>

//           {/* Initial loading spinner */}
//           {ordersInitialLoading && orders.length === 0 && (
//             <Box display="flex" justifyContent="center" py={8}>
//               <CircularProgress sx={{ color: BRAND.primary }} />
//             </Box>
//           )}

//           {/* Orders list */}
//           {orders.map((order) => {
//             const isAssignedToMe = order.deliveryBoy === myId;
//             const isUnassigned = !order.deliveryBoy;
//             const isCash = order.paymentMethod === "CASH";
//             const cfg = ORDER_STATUS_CFG[order.status] || ORDER_STATUS_CFG.PENDING;

//             return (
//               <Card
//                 key={order._id}
//                 onClick={() => { setSelectedOrder(order); setDetailsOpen(true); }}
//                 elevation={0}
//                 sx={{
//                   mb: 1.75, borderRadius: 3, border: "1px solid #f1f5f9",
//                   position: "relative", overflow: "hidden", cursor: "pointer",
//                   transition: "all 0.2s",
//                   "&:hover": { boxShadow: "0 6px 20px rgba(0,0,0,0.06)", transform: "translateY(-2px)" },
//                 }}
//               >
//                 <Box sx={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 4, bgcolor: cfg.color }} />
//                 <CardContent sx={{ pl: 2.5, p: 2, "&:last-child": { pb: 2 } }}>
//                   <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.25}>
//                     <Box>
//                       <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Order</Typography>
//                       <Typography sx={{ fontSize: 15, fontWeight: 800, fontFamily: "monospace", color: "#0f172a", lineHeight: 1.2 }}>
//                         #{order._id.slice(-6).toUpperCase()}
//                       </Typography>
//                       <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.25 }}>🕒 {formatOrderDateTime(order.createdAt)}</Typography>
//                     </Box>
//                     <Chip label={cfg.label} size="small" sx={{ bgcolor: cfg.bg, color: cfg.color, fontWeight: 700, fontSize: 10, height: 22 }} />
//                   </Box>

//                   <Box display="flex" alignItems="flex-start" gap={1} mb={1}>
//                     <LocalDining sx={{ fontSize: 16, color: BRAND.primary, mt: 0.2, flexShrink: 0 }} />
//                     <Box flex={1} minWidth={0}>
//                       <Typography sx={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3 }}>{order.restaurant?.restaurantName}</Typography>
//                       <Typography sx={{ fontSize: 11, color: "#64748b", lineHeight: 1.3 }}>
//                         {order.restaurant?.restaurantAddress || order.restaurant?.address || "—"}
//                       </Typography>
//                     </Box>
//                   </Box>

//                   <Box display="flex" alignItems="flex-start" gap={1} mb={1.5}>
//                     <Person sx={{ fontSize: 16, color: "#3b82f6", mt: 0.2, flexShrink: 0 }} />
//                     <Box flex={1} minWidth={0}>
//                       <Typography sx={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3 }}>
//                         {order.customer?.name} {order.customer?.phone && <span style={{ color: "#64748b", fontWeight: 500 }}>• {order.customer.phone}</span>}
//                       </Typography>
//                       <Typography sx={{ fontSize: 11, color: "#64748b", lineHeight: 1.3 }}>{order.customer?.address || "Address not provided"}</Typography>
//                     </Box>
//                   </Box>

//                   <Divider sx={{ mb: 1.5, borderColor: "#f1f5f9" }} />

//                   <Box display="flex" justifyContent="space-between" alignItems="center">
//                     <Box>
//                       <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>Amount</Typography>
//                       <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#0f172a", lineHeight: 1.1 }}>₹{order.orderSummary?.totalAmount || 0}</Typography>
//                       <Typography sx={{ fontSize: 10, color: isCash ? "#dc2626" : "#16a34a", fontWeight: 700 }}>
//                         {isCash ? "Collect Cash" : "Paid Online"}
//                       </Typography>
//                     </Box>

//                     {isUnassigned && (
//                       <Button
//                         variant="contained"
//                         size="small"
//                         startIcon={<TouchApp sx={{ fontSize: 16 }} />}
//                         onClick={(e) => handleAcceptOrder(order._id, e)}
//                         sx={{
//                           borderRadius: 2, textTransform: "none", fontWeight: 700, fontSize: 12,
//                           bgcolor: BRAND.primary, "&:hover": { bgcolor: BRAND.primaryDark },
//                           boxShadow: "0 4px 12px rgba(255,107,0,0.25)",
//                         }}
//                       >
//                         Accept
//                       </Button>
//                     )}

//                     {isAssignedToMe && order.status !== "DELIVERED" && (
//                       <Chip icon={<CheckCircle sx={{ fontSize: "14px !important" }} />} label="Assigned" size="small" sx={{ bgcolor: "#fef3c7", color: "#d97706", fontWeight: 700, fontSize: 10, height: 24 }} />
//                     )}

//                     {order.status === "DELIVERED" && (
//                       <Chip icon={<CheckCircle sx={{ fontSize: "14px !important" }} />} label="Completed" size="small" sx={{ bgcolor: "#d1fae5", color: "#059669", fontWeight: 700, fontSize: 10, height: 24 }} />
//                     )}
//                   </Box>
//                 </CardContent>
//               </Card>
//             );
//           })}

//           {/* Infinite scroll loader / sentinel */}
//           {orders.length > 0 && (
//             <Box ref={ordersLoadMoreRef} display="flex" justifyContent="center" py={2}>
//               {ordersLoading && <CircularProgress size={24} sx={{ color: BRAND.primary }} />}
//               {!ordersHasMore && !ordersLoading && (
//                 <Typography variant="caption" sx={{ color: "#94a3b8", fontSize: 11 }}>
//                   — No more orders —
//                 </Typography>
//               )}
//             </Box>
//           )}

//           {/* Empty state */}
//           {!ordersInitialLoading && orders.length === 0 && (
//             <Box textAlign="center" py={10}>
//               <Box sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
//                 <Moped sx={{ fontSize: 40, color: "#cbd5e1" }} />
//               </Box>
//               <Typography sx={{ fontWeight: 700, color: "#475569", mb: 0.5 }}>
//                 {orderFilter === "AVAILABLE" ? "No new orders" : orderFilter === "MY_ORDERS" ? "No active orders" : "No delivered orders yet"}
//               </Typography>
//               <Typography variant="caption" sx={{ color: "#94a3b8", maxWidth: 260, display: "inline-block" }}>
//                 {orderFilter === "AVAILABLE" ? "New delivery orders will appear here automatically." : orderFilter === "MY_ORDERS" ? "Accept an order from the New tab to see it here." : "Your delivered orders will be listed here."}
//               </Typography>
//             </Box>
//           )}
//         </Box>
//       )}

//       {/* ══════════════ TAB 1: HOTELS ══════════════ */}
//       {navTab === 1 && (
//         <Box p={2}>
//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//             <Box>
//               <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Restaurants</Typography>
//               <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0f172a" }}>Active Partners</Typography>
//             </Box>
//             <Chip label={`${restaurants.length}${restHasMore ? "+" : ""}`} size="small" sx={{ bgcolor: BRAND.primary, color: "#fff", fontWeight: 800, minWidth: 32 }} />
//           </Box>

//           {restInitialLoading && restaurants.length === 0 && (
//             <Box display="flex" justifyContent="center" py={8}>
//               <CircularProgress sx={{ color: BRAND.primary }} />
//             </Box>
//           )}

//           {restaurants.map((rest) => {
//             const hasUpi = rest.payment?.upiEnabled && rest.payment?.upiId;
//             const hasPhonePe = rest.payment?.phonePeEnabled && rest.payment?.phonePeNumber;
//             const hasAnyPayment = rest.payment?.cashEnabled || hasUpi || hasPhonePe;

//             return (
//               <Card
//                 key={rest._id}
//                 elevation={0}
//                 sx={{
//                   mb: 2, borderRadius: 3, overflow: "hidden",
//                   border: "1px solid #f1f5f9",
//                   transition: "all 0.2s",
//                   "&:hover": { boxShadow: "0 8px 24px rgba(255,107,0,0.08)", transform: "translateY(-2px)" },
//                 }}
//               >
//                 <Box
//                   sx={{
//                     p: 2,
//                     background: "linear-gradient(135deg, #FFF9F5 0%, #FFFFFF 100%)",
//                     borderBottom: "1px solid #f1f5f9",
//                     position: "relative",
//                     overflow: "hidden",
//                     "&::before": {
//                       content: '""',
//                       position: "absolute",
//                       top: -30, right: -30,
//                       width: 100, height: 100,
//                       borderRadius: "50%",
//                       bgcolor: "rgba(255,107,0,0.06)",
//                       pointerEvents: "none",
//                     },
//                   }}
//                 >
//                   <Box display="flex" alignItems="center" gap={1.5} position="relative" zIndex={1}>
//                     <Avatar
//                       sx={{
//                         width: 52, height: 52,
//                         background: BRAND.gradient,
//                         fontWeight: 800, fontSize: 22,
//                         boxShadow: "0 4px 12px rgba(255,107,0,0.25)",
//                         border: "2px solid #fff",
//                       }}
//                     >
//                       {rest.restaurantName?.[0]?.toUpperCase() || "R"}
//                     </Avatar>
//                     <Box flex={1} minWidth={0}>
//                       <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#0f172a", lineHeight: 1.2, mb: 0.5 }} noWrap>
//                         {rest.restaurantName}
//                       </Typography>
//                       <Box display="flex" alignItems="center" gap={0.75} flexWrap="wrap">
//                         <Chip
//                           icon={<CheckCircle sx={{ fontSize: "11px !important" }} />}
//                           label="Delivery Active"
//                           size="small"
//                           sx={{
//                             height: 20, fontSize: 9.5,
//                             bgcolor: "#d1fae5", color: "#059669", fontWeight: 700,
//                             "& .MuiChip-icon": { color: "#059669" },
//                             "& .MuiChip-label": { px: 0.75 },
//                           }}
//                         />
//                         {rest.city && (
//                           <Typography sx={{ fontSize: 10.5, color: "#94a3b8", fontWeight: 600 }}>
//                             📍 {rest.city}{rest.state ? `, ${rest.state}` : ""}
//                           </Typography>
//                         )}
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Box>

//                 <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
//                   <Stack spacing={1.25} mb={hasAnyPayment ? 1.5 : 0}>
//                     <Box display="flex" gap={1.25}>
//                       <Box
//                         sx={{
//                           width: 28, height: 28, borderRadius: 1.5,
//                           bgcolor: "#FFF4EC",
//                           display: "flex", alignItems: "center", justifyContent: "center",
//                           flexShrink: 0,
//                         }}
//                       >
//                         <LocationOn sx={{ fontSize: 15, color: BRAND.primary }} />
//                       </Box>
//                       <Box flex={1} minWidth={0}>
//                         <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", lineHeight: 1 }}>
//                           Address
//                         </Typography>
//                         <Typography sx={{ fontSize: 12, color: "#334155", lineHeight: 1.4, mt: 0.25 }}>
//                           {rest.restaurantAddress || rest.address || "—"}
//                         </Typography>
//                       </Box>
//                     </Box>

//                     <Box display="flex" gap={1.25}>
//                       <Box
//                         sx={{
//                           width: 28, height: 28, borderRadius: 1.5,
//                           bgcolor: "#dbeafe",
//                           display: "flex", alignItems: "center", justifyContent: "center",
//                           flexShrink: 0,
//                         }}
//                       >
//                         <Schedule sx={{ fontSize: 15, color: "#2563eb" }} />
//                       </Box>
//                       <Box>
//                         <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", lineHeight: 1 }}>
//                           Timings
//                         </Typography>
//                         <Typography sx={{ fontSize: 12, color: "#334155", fontWeight: 600, mt: 0.25 }}>
//                           {rest.openingTime || "—"} – {rest.closingTime || "—"}
//                         </Typography>
//                       </Box>
//                     </Box>

//                     {(rest.mobile || rest.whatsappNumber) && (
//                       <Box
//                         display="flex" gap={1.25}
//                         component="a"
//                         href={`tel:${rest.mobile || rest.whatsappNumber}`}
//                         sx={{ textDecoration: "none", color: "inherit" }}
//                       >
//                         <Box
//                           sx={{
//                             width: 28, height: 28, borderRadius: 1.5,
//                             bgcolor: "#d1fae5",
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             flexShrink: 0,
//                           }}
//                         >
//                           <Phone sx={{ fontSize: 15, color: "#059669" }} />
//                         </Box>
//                         <Box>
//                           <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", lineHeight: 1 }}>
//                             Contact
//                           </Typography>
//                           <Typography sx={{ fontSize: 12, color: BRAND.primaryDark, fontWeight: 700, mt: 0.25 }}>
//                             {rest.mobile || rest.whatsappNumber}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     )}
//                   </Stack>

//                   {hasAnyPayment && <Divider sx={{ my: 1.5, borderColor: "#f1f5f9" }} />}

//                   {hasAnyPayment && (
//                     <>
//                       <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, mb: 1 }}>
//                         PAYMENT METHODS
//                       </Typography>
//                       <Box display="flex" gap={0.75} flexWrap="wrap" mb={2}>
//                         {rest.payment?.cashEnabled && (
//                           <Chip label="💵 Cash" size="small" sx={{ bgcolor: "#ecfdf5", color: "#059669", fontWeight: 700, fontSize: 10, height: 22 }} />
//                         )}
//                         {hasUpi && (
//                           <Chip label="📱 UPI" size="small" sx={{ bgcolor: "#eff6ff", color: "#2563eb", fontWeight: 700, fontSize: 10, height: 22 }} />
//                         )}
//                         {hasPhonePe && (
//                           <Chip label="💜 PhonePe" size="small" sx={{ bgcolor: "#f5f3ff", color: "#7c3aed", fontWeight: 700, fontSize: 10, height: 22 }} />
//                         )}
//                       </Box>
//                     </>
//                   )}

//                   <Box display="flex" gap={1}>
//                     {hasUpi && (
//                       <Button
//                         fullWidth
//                         variant="contained"
//                         size="small"
//                         startIcon={<QrCode2 sx={{ fontSize: 16 }} />}
//                         onClick={() => openQRDialog(rest, "UPI")}
//                         sx={{
//                           background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
//                           "&:hover": { background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)" },
//                           fontWeight: 700, textTransform: "none",
//                           borderRadius: 2, py: 0.85, fontSize: 11,
//                           boxShadow: "0 4px 12px rgba(37,99,235,0.25)",
//                         }}
//                       >
//                         UPI QR
//                       </Button>
//                     )}
//                     {hasPhonePe && (
//                       <Button
//                         fullWidth
//                         variant="contained"
//                         size="small"
//                         startIcon={<QrCode2 sx={{ fontSize: 16 }} />}
//                         onClick={() => openQRDialog(rest, "PhonePe")}
//                         sx={{
//                           background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
//                           "&:hover": { background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)" },
//                           fontWeight: 700, textTransform: "none",
//                           borderRadius: 2, py: 0.85, fontSize: 11,
//                           boxShadow: "0 4px 12px rgba(124,58,237,0.25)",
//                         }}
//                       >
//                         PhonePe QR
//                       </Button>
//                     )}
//                   </Box>
//                 </CardContent>
//               </Card>
//             );
//           })}

//           {/* Infinite scroll loader for restaurants */}
//           {restaurants.length > 0 && (
//             <Box ref={restLoadMoreRef} display="flex" justifyContent="center" py={2}>
//               {restLoading && <CircularProgress size={24} sx={{ color: BRAND.primary }} />}
//               {!restHasMore && !restLoading && (
//                 <Typography variant="caption" sx={{ color: "#94a3b8", fontSize: 11 }}>
//                   — No more restaurants —
//                 </Typography>
//               )}
//             </Box>
//           )}

//           {!restInitialLoading && restaurants.length === 0 && (
//             <Box textAlign="center" py={10}>
//               <Box sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
//                 <Storefront sx={{ fontSize: 40, color: "#cbd5e1" }} />
//               </Box>
//               <Typography sx={{ fontWeight: 700, color: "#475569", mb: 0.5 }}>No restaurants yet</Typography>
//               <Typography variant="caption" sx={{ color: "#94a3b8" }}>
//                 Restaurants in {profile.city || "your city"} will appear here.
//               </Typography>
//             </Box>
//           )}
//         </Box>
//       )}

//       {/* ══════════════ TAB 2: EARNINGS ══════════════ */}
//       {navTab === 2 && (
//         <Box p={2}>
//           <Grid container spacing={1.5} mb={2.5}>
//             <Grid item xs={4}>
//               <Card
//                 elevation={0}
//                 sx={{
//                   p: 1.75, borderRadius: 3,
//                   border: "1px solid #fecaca",
//                   background: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",
//                   textAlign: "center", height: "100%",
//                 }}
//               >
//                 <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#dc2626", letterSpacing: 0.5, mb: 0.5 }}>TO DEPOSIT</Typography>
//                 <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#dc2626", lineHeight: 1.1 }}>₹{pendingCodAmount}</Typography>
//               </Card>
//             </Grid>
//             <Grid item xs={4}>
//               <Card
//                 elevation={0}
//                 sx={{
//                   p: 1.75, borderRadius: 3,
//                   border: "1px solid #fde68a",
//                   background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
//                   textAlign: "center", height: "100%",
//                 }}
//               >
//                 <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#d97706", letterSpacing: 0.5, mb: 0.5 }}>IN REVIEW</Typography>
//                 <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#d97706", lineHeight: 1.1 }}>₹{underReviewCodAmount}</Typography>
//               </Card>
//             </Grid>
//             <Grid item xs={4}>
//               <Card
//                 elevation={0}
//                 sx={{
//                   p: 1.75, borderRadius: 3,
//                   border: "1px solid #bbf7d0",
//                   background: "linear-gradient(135deg, #f0fdf4 0%, #d1fae5 100%)",
//                   textAlign: "center", height: "100%",
//                 }}
//               >
//                 <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#059669", letterSpacing: 0.5, mb: 0.5 }}>SETTLED</Typography>
//                 <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#059669", lineHeight: 1.1 }}>₹{settledCodAmount}</Typography>
//               </Card>
//             </Grid>
//           </Grid>

//           <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
//             <Box>
//               <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Cash In Hand</Typography>
//               <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0f172a" }}>Order-wise Breakdown</Typography>
//             </Box>
//             <Chip label={`${myCodOrders.length} orders`} size="small" sx={{ bgcolor: "#f1f5f9", color: "#64748b", fontWeight: 700, fontSize: 10, height: 22 }} />
//           </Box>

//           {myCodOrders.map((order) => {
//             const settlementStatus = order.codSettlement?.status || "UNSETTLED";
//             const cfg = COD_STATUS_CFG[settlementStatus] || COD_STATUS_CFG.UNSETTLED;
//             const isPaid = settlementStatus === "PAID";
//             const isUnderReview = settlementStatus === "UNDER_REVIEW";
//             const isActionable = ["UNSETTLED", "REJECTED"].includes(settlementStatus);

//             return (
//               <Card
//                 key={order._id}
//                 elevation={0}
//                 sx={{ mb: 1.75, borderRadius: 3, border: "1px solid #f1f5f9", overflow: "hidden", position: "relative" }}
//               >
//                 <Box sx={{ height: 3, bgcolor: cfg.color }} />

//                 <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
//                   <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.25}>
//                     <Box>
//                       <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Order</Typography>
//                       <Typography sx={{ fontSize: 14, fontWeight: 800, fontFamily: "monospace", color: "#0f172a", lineHeight: 1.2 }}>
//                         #{order._id.slice(-6).toUpperCase()}
//                       </Typography>
//                       <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.25 }}>🕒 {formatOrderDateTime(order.createdAt)}</Typography>
//                     </Box>
//                     <Chip
//                       icon={cfg.icon}
//                       label={cfg.label}
//                       size="small"
//                       sx={{
//                         bgcolor: cfg.bg, color: cfg.color, fontWeight: 800, fontSize: 10, height: 24,
//                         "& .MuiChip-icon": { color: `${cfg.color} !important`, ml: 0.75 },
//                       }}
//                     />
//                   </Box>

//                   <Box sx={{ p: 1.25, bgcolor: "#f8fafc", borderRadius: 2, border: "1px solid #f1f5f9", mb: 1.5 }}>
//                     <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, mb: 0.5 }}>PAY TO RESTAURANT</Typography>
//                     <Box display="flex" alignItems="center" gap={1}>
//                       <Avatar sx={{ width: 32, height: 32, bgcolor: "#FFF4EC", color: BRAND.primary, fontSize: 14, fontWeight: 800 }}>
//                         {order.restaurant?.restaurantName?.[0]?.toUpperCase() || "R"}
//                       </Avatar>
//                       <Box flex={1} minWidth={0}>
//                         <Typography sx={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3 }} noWrap>
//                           {order.restaurant?.restaurantName || "Restaurant"}
//                         </Typography>
//                         <Typography sx={{ fontSize: 10.5, color: "#64748b", lineHeight: 1.3 }} noWrap>
//                           {order.restaurant?.mobile || order.restaurant?.whatsappNumber || "—"}
//                         </Typography>
//                       </Box>
//                       <IconButton
//                         size="small"
//                         href={`tel:${order.restaurant?.mobile || order.restaurant?.whatsappNumber || ""}`}
//                         sx={{ bgcolor: "#fff", color: BRAND.primary, border: "1px solid #f1f5f9" }}
//                       >
//                         <Call sx={{ fontSize: 16 }} />
//                       </IconButton>
//                     </Box>
//                   </Box>

//                   <Box display="flex" justifyContent="space-between" alignItems="center">
//                     <Box>
//                       <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>COD Collected</Typography>
//                       <Typography sx={{ fontSize: 20, fontWeight: 800, color: "#0f172a", lineHeight: 1.1 }}>
//                         ₹{order.orderSummary?.totalAmount || 0}
//                       </Typography>
//                     </Box>

//                     {isPaid && (
//                       <Box display="flex" alignItems="center" gap={0.5} sx={{ color: "#059669" }}>
//                         <CheckCircle sx={{ fontSize: 18 }} />
//                         <Typography sx={{ fontSize: 12, fontWeight: 700 }}>Settled</Typography>
//                       </Box>
//                     )}

//                     {isUnderReview && (
//                       <Typography sx={{ fontSize: 11, color: "#d97706", fontWeight: 700, textAlign: "right" }}>
//                         Awaiting restaurant
//                         <br />confirmation ⏳
//                       </Typography>
//                     )}

//                     {isActionable && (
//                       <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.75}>
//                         {settlementStatus === "REJECTED" && (
//                           <Typography sx={{ fontSize: 10, color: "#dc2626", fontWeight: 700 }}>❌ Rejected — retry</Typography>
//                         )}
//                         <Button
//                           variant="contained"
//                           size="small"
//                           startIcon={<Payment sx={{ fontSize: 16 }} />}
//                           onClick={() => handlePayToRestaurant(order._id)}
//                           sx={{
//                             borderRadius: 2, textTransform: "none", fontWeight: 700, fontSize: 11,
//                             bgcolor: BRAND.primary, "&:hover": { bgcolor: BRAND.primaryDark },
//                             boxShadow: "0 4px 12px rgba(255,107,0,0.25)",
//                           }}
//                         >
//                           Pay Now
//                         </Button>
//                       </Box>
//                     )}
//                   </Box>
//                 </CardContent>
//               </Card>
//             );
//           })}

//           {myCodOrders.length === 0 && (
//             <Box textAlign="center" py={10}>
//               <Box sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
//                 <AccountBalanceWallet sx={{ fontSize: 40, color: "#cbd5e1" }} />
//               </Box>
//               <Typography sx={{ fontWeight: 700, color: "#475569", mb: 0.5 }}>No COD orders</Typography>
//               <Typography variant="caption" sx={{ color: "#94a3b8" }}>
//                 Cash on delivery orders will appear here after delivery.
//               </Typography>
//             </Box>
//           )}
//         </Box>
//       )}

//       {/* ══════════════ TAB 3: PROFILE ══════════════ */}
//       {navTab === 3 && (
//         <Box p={2}>
//           <Card elevation={0} sx={{ borderRadius: 3, mb: 2, overflow: "hidden", border: "1px solid #f1f5f9" }}>
//             <Box sx={{ height: 80, background: BRAND.gradient, position: "relative" }} />
//             <Box sx={{ px: 2, pb: 2, mt: -5, position: "relative" }}>
//               <Box position="relative" display="inline-block">
//                 <Avatar
//                   src={newProfileImage ? URL.createObjectURL(newProfileImage) : profile.profileImage?.url}
//                   sx={{
//                     width: 82, height: 82,
//                     border: "4px solid #fff",
//                     boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
//                     fontSize: 30, fontWeight: 800,
//                     bgcolor: BRAND.primary,
//                   }}
//                 >
//                   {profile.name?.[0]?.toUpperCase()}
//                 </Avatar>
//                 <Box
//                   component="label"
//                   sx={{
//                     position: "absolute", bottom: 2, right: 2,
//                     width: 28, height: 28, borderRadius: "50%",
//                     bgcolor: BRAND.primary, color: "#fff",
//                     display: "flex", alignItems: "center", justifyContent: "center",
//                     border: "2px solid #fff", cursor: "pointer",
//                     boxShadow: "0 2px 8px rgba(255,107,0,0.4)",
//                     transition: "all 0.2s",
//                     "&:hover": { bgcolor: BRAND.primaryDark, transform: "scale(1.05)" },
//                   }}
//                 >
//                   <CameraAlt sx={{ fontSize: 14 }} />
//                   <input type="file" accept="image/*" hidden onChange={(e) => setNewProfileImage(e.target.files[0])} />
//                 </Box>
//               </Box>
//               <Typography sx={{ fontSize: 17, fontWeight: 800, mt: 1.5, color: "#0f172a" }}>
//                 {profile.name || "Delivery Partner"}
//               </Typography>
//               <Typography sx={{ fontSize: 12, color: "#64748b" }}>
//                 📍 {profile.city?.toUpperCase() || "N/A"} • {profile.phone || "N/A"}
//               </Typography>
//             </Box>
//           </Card>

//           <Card elevation={0} sx={{ borderRadius: 3, p: 2, mb: 2, border: "1px solid #f1f5f9" }}>
//             <Box display="flex" alignItems="center" gap={1} mb={2}>
//               <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: "#FFF4EC", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <Person sx={{ fontSize: 16, color: BRAND.primary }} />
//               </Box>
//               <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>Personal Info</Typography>
//             </Box>

//             <form onSubmit={handleSaveProfile}>
//               <Stack spacing={1.5}>
//                 <TextField fullWidth size="small" label="Full Name" value={profileForm.name} onChange={(e) => setProfileForm({ ...profileForm, name: e.target.value })} sx={textFieldSx} />
//                 <TextField fullWidth size="small" label="Phone" value={profileForm.phone} onChange={(e) => setProfileForm({ ...profileForm, phone: e.target.value })} sx={textFieldSx} />
//                 <TextField fullWidth size="small" label="Assigned City" value={profile.city?.toUpperCase() || ""} disabled sx={textFieldSx} />
//                 <TextField fullWidth size="small" label="Vehicle Number" value={profileForm.vehicleNumber} onChange={(e) => setProfileForm({ ...profileForm, vehicleNumber: e.target.value })} sx={textFieldSx} />
//                 <TextField fullWidth size="small" multiline rows={2} label="Address" value={profileForm.address} onChange={(e) => setProfileForm({ ...profileForm, address: e.target.value })} sx={textFieldSx} />
//                 <Button
//                   fullWidth type="submit" variant="contained" disabled={savingProfile}
//                   sx={{
//                     mt: 1, py: 1.1,
//                     bgcolor: BRAND.primary, "&:hover": { bgcolor: BRAND.primaryDark },
//                     fontWeight: 700, textTransform: "none", borderRadius: 2,
//                     boxShadow: "0 4px 12px rgba(255,107,0,0.25)",
//                   }}
//                 >
//                   {savingProfile ? "Saving..." : "Save Details"}
//                 </Button>
//               </Stack>
//             </form>
//           </Card>

//           <Card elevation={0} sx={{ borderRadius: 3, p: 2, border: "1px solid #f1f5f9" }}>
//             <Box display="flex" alignItems="center" gap={1} mb={2}>
//               <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <Refresh sx={{ fontSize: 16, color: "#2563eb" }} />
//               </Box>
//               <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>Change Password</Typography>
//             </Box>

//             <form onSubmit={handleChangePassword}>
//               <Stack spacing={1.5}>
//                 <TextField fullWidth size="small" label="Current Password" type="password" required value={passwordForm.currentPassword} onChange={(e) => setPasswordForm({ ...passwordForm, currentPassword: e.target.value })} sx={textFieldSx} />
//                 <TextField fullWidth size="small" label="New Password" type="password" required value={passwordForm.newPassword} onChange={(e) => setPasswordForm({ ...passwordForm, newPassword: e.target.value })} sx={textFieldSx} />
//                 <Button
//                   fullWidth type="submit" variant="outlined"
//                   sx={{
//                     mt: 1, py: 1.1,
//                     borderColor: BRAND.primary, color: BRAND.primaryDark,
//                     fontWeight: 700, textTransform: "none", borderRadius: 2,
//                     "&:hover": { borderColor: BRAND.primaryDark, bgcolor: "#FFF4EC" },
//                   }}
//                 >
//                   Update Password
//                 </Button>
//               </Stack>
//             </form>
//           </Card>
//         </Box>
//       )}

//       {/* ══════════════ ORDER DETAILS DIALOG ══════════════ */}
//       <Dialog fullScreen open={detailsOpen} onClose={() => setDetailsOpen(false)} TransitionComponent={Transition}>
//         <DialogTitle
//           sx={{
//             p: 2, display: "flex", justifyContent: "space-between", alignItems: "center",
//             bgcolor: "#fff", borderBottom: "1px solid #f1f5f9", color: "#0f172a",
//           }}
//         >
//           <Box display="flex" alignItems="center" gap={1.5}>
//             <Box sx={{ width: 40, height: 40, borderRadius: 2, background: BRAND.gradient, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
//               <Receipt sx={{ fontSize: 22 }} />
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Order</Typography>
//               <Typography sx={{ fontSize: 15, fontWeight: 800, fontFamily: "monospace", lineHeight: 1.1 }}>
//                 #{selectedOrder?._id?.slice(-6).toUpperCase()}
//               </Typography>
//               <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.2 }}>{formatOrderDateTime(selectedOrder?.createdAt)}</Typography>
//             </Box>
//           </Box>
//           <IconButton onClick={() => setDetailsOpen(false)} sx={{ bgcolor: "#f8fafc" }}>
//             <Close />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent sx={{ p: 2, bgcolor: "#f8fafc" }}>
//           {selectedOrder && (
//             <Box>
//               <Card
//                 elevation={0}
//                 sx={{
//                   p: 1.5, mb: 2, borderRadius: 2.5,
//                   bgcolor: (ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).bg,
//                   border: "1px solid",
//                   borderColor: (ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).color + "40",
//                 }}
//               >
//                 <Box display="flex" alignItems="center" justifyContent="space-between">
//                   <Typography sx={{ fontSize: 11, fontWeight: 800, color: (ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).color, letterSpacing: 0.5, textTransform: "uppercase" }}>
//                     Current Status
//                   </Typography>
//                   <Chip
//                     label={(ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).label}
//                     size="small"
//                     sx={{ bgcolor: "#fff", color: (ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).color, fontWeight: 800, fontSize: 10, height: 22 }}
//                   />
//                 </Box>
//               </Card>

//               <Card elevation={0} sx={{ p: 2, mb: 2, borderRadius: 3, border: "1px solid #fed7aa", bgcolor: "#fff" }}>
//                 <Box display="flex" alignItems="center" gap={1} mb={1.5}>
//                   <Box sx={{ width: 32, height: 32, borderRadius: 2, bgcolor: "#fef3c7", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                     <Storefront sx={{ fontSize: 18, color: "#d97706" }} />
//                   </Box>
//                   <Box>
//                     <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#d97706", letterSpacing: 0.75, textTransform: "uppercase" }}>Pickup From</Typography>
//                     <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}>
//                       {selectedOrder.restaurant?.restaurantName}
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Typography sx={{ fontSize: 12, color: "#64748b", mb: 0.5, lineHeight: 1.4 }}>
//                   {selectedOrder.restaurant?.restaurantAddress || selectedOrder.restaurant?.address}
//                 </Typography>
//                 <Typography sx={{ fontSize: 12, color: "#64748b" }}>
//                   📞 {selectedOrder.restaurant?.mobile || selectedOrder.restaurant?.whatsappNumber || "N/A"}
//                 </Typography>
//                 <Box display="flex" gap={1} mt={1.5}>
//                   {selectedOrder.restaurant?.mobile && (
//                     <Button
//                       fullWidth size="small" variant="outlined" startIcon={<Call sx={{ fontSize: 16 }} />}
//                       href={`tel:${selectedOrder.restaurant.mobile}`}
//                       sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, borderColor: "#d97706", color: "#d97706" }}
//                     >
//                       Call
//                     </Button>
//                   )}
//                   <Button
//                     fullWidth size="small" variant="outlined" startIcon={<Navigation sx={{ fontSize: 16 }} />}
//                     href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(selectedOrder.restaurant?.restaurantAddress || "")}`}
//                     target="_blank"
//                     sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, borderColor: "#d97706", color: "#d97706" }}
//                   >
//                     Map
//                   </Button>
//                 </Box>
//               </Card>

//               <Card elevation={0} sx={{ p: 2, mb: 2, borderRadius: 3, border: "1px solid #bfdbfe", bgcolor: "#fff" }}>
//                 <Box display="flex" alignItems="center" gap={1} mb={1.5}>
//                   <Box sx={{ width: 32, height: 32, borderRadius: 2, bgcolor: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                     <Home sx={{ fontSize: 18, color: "#2563eb" }} />
//                   </Box>
//                   <Box>
//                     <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#2563eb", letterSpacing: 0.75, textTransform: "uppercase" }}>Deliver To</Typography>
//                     <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}>{selectedOrder.customer?.name}</Typography>
//                   </Box>
//                 </Box>
//                 <Typography sx={{ fontSize: 12, color: "#64748b", mb: 0.5, lineHeight: 1.4 }}>
//                   {selectedOrder.customer?.address || "No address provided"}
//                 </Typography>
//                 <Typography sx={{ fontSize: 12, color: "#64748b" }}>📞 {selectedOrder.customer?.phone || "N/A"}</Typography>
//                 <Box display="flex" gap={1} mt={1.5}>
//                   <Button
//                     fullWidth size="small" variant="contained" startIcon={<Call sx={{ fontSize: 16 }} />}
//                     href={`tel:${selectedOrder.customer?.phone}`}
//                     sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, bgcolor: "#2563eb", "&:hover": { bgcolor: "#1d4ed8" } }}
//                   >
//                     Call
//                   </Button>
//                   <Button
//                     fullWidth size="small" variant="outlined" startIcon={<Navigation sx={{ fontSize: 16 }} />}
//                     href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(selectedOrder.customer?.address || "")}`}
//                     target="_blank"
//                     sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, borderColor: "#2563eb", color: "#2563eb" }}
//                   >
//                     Map
//                   </Button>
//                 </Box>
//               </Card>

//               <Card elevation={0} sx={{ p: 2, mb: 2, borderRadius: 3, border: "1px solid #f1f5f9", bgcolor: "#fff" }}>
//                 <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", mb: 1 }}>Order Items</Typography>
//                 {selectedOrder.items?.map((item, idx) => (
//                   <Box key={idx} py={0.75} display="flex" justifyContent="space-between" alignItems="center">
//                     <Box>
//                       <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{item.itemName}</Typography>
//                       <Typography sx={{ fontSize: 10.5, color: "#94a3b8" }}>Qty: {item.quantity} × ₹{item.price}</Typography>
//                     </Box>
//                     <Typography sx={{ fontSize: 13, fontWeight: 800 }}>₹{item.total || item.price * item.quantity}</Typography>
//                   </Box>
//                 ))}
//                 <Divider sx={{ my: 1.5 }} />
//                 <Box display="flex" justifyContent="space-between" alignItems="center">
//                   <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Total</Typography>
//                   <Typography sx={{ fontSize: 20, fontWeight: 800, color: BRAND.primaryDark }}>
//                     ₹{selectedOrder.orderSummary?.totalAmount || 0}
//                   </Typography>
//                 </Box>
//               </Card>

//               <Card
//                 elevation={0}
//                 sx={{
//                   p: 2, mb: 2, borderRadius: 3,
//                   bgcolor: selectedOrder.paymentMethod === "CASH" ? "#fef2f2" : "#f0fdf4",
//                   border: "1px solid",
//                   borderColor: selectedOrder.paymentMethod === "CASH" ? "#fecaca" : "#bbf7d0",
//                 }}
//               >
//                 <Box display="flex" alignItems="center" gap={1}>
//                   <Box sx={{ width: 32, height: 32, borderRadius: 2, bgcolor: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                     {selectedOrder.paymentMethod === "CASH"
//                       ? <Warning sx={{ fontSize: 18, color: "#dc2626" }} />
//                       : <CheckCircle sx={{ fontSize: 18, color: "#059669" }} />}
//                   </Box>
//                   <Box flex={1}>
//                     <Typography sx={{ fontSize: 9, fontWeight: 800, color: selectedOrder.paymentMethod === "CASH" ? "#dc2626" : "#059669", letterSpacing: 0.75, textTransform: "uppercase" }}>
//                       {selectedOrder.paymentMethod === "CASH" ? "Collect Cash" : "Payment Status"}
//                     </Typography>
//                     <Typography sx={{ fontSize: 13, fontWeight: 700, color: selectedOrder.paymentMethod === "CASH" ? "#dc2626" : "#059669" }}>
//                       {selectedOrder.paymentMethod === "CASH"
//                         ? `₹${selectedOrder.orderSummary?.totalAmount || 0} from customer`
//                         : "Already paid online ✓"}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Card>

//               {selectedOrder.deliveryBoy === myId && selectedOrder.status !== "DELIVERED" && (
//                 <Card elevation={0} sx={{ p: 2, mb: 2, borderRadius: 3, border: "1px solid #f1f5f9", bgcolor: "#fff" }}>
//                   <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", mb: 1.5 }}>
//                     Update Delivery Status
//                   </Typography>
//                   <FormControl fullWidth size="small">
//                     <InputLabel>Status</InputLabel>
//                     <Select
//                       value={selectedOrder.status}
//                       label="Status"
//                       onChange={(e) => handleUpdateStatus(selectedOrder._id, e.target.value)}
//                       sx={{ borderRadius: 2, fontSize: 13 }}
//                     >
//                       <MenuItem value="PREPARING">👨‍🍳 Preparing (Cooking)</MenuItem>
//                       <MenuItem value="OUT_FOR_DELIVERY">🛵 Out for Delivery</MenuItem>
//                       <MenuItem value="DELIVERED">✅ Delivered</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Card>
//               )}

//               {!selectedOrder.deliveryBoy && (
//                 <Button
//                   fullWidth variant="contained" size="large"
//                   onClick={() => handleAcceptOrder(selectedOrder._id)}
//                   sx={{
//                     py: 1.5, fontWeight: 800, textTransform: "none", borderRadius: 2.5,
//                     bgcolor: BRAND.primary, "&:hover": { bgcolor: BRAND.primaryDark },
//                     boxShadow: "0 8px 20px rgba(255,107,0,0.35)", mb: 2,
//                   }}
//                 >
//                   Accept & Assign to Me
//                 </Button>
//               )}
//             </Box>
//           )}
//         </DialogContent>
//       </Dialog>

//       {/* ══════════════ QR DIALOG ══════════════ */}
//       <Dialog open={qrDialog.open} onClose={closeQRDialog} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
//         <DialogTitle sx={{ textAlign: "center", pb: 1, position: "relative" }}>
//           <IconButton onClick={closeQRDialog} size="small" sx={{ position: "absolute", top: 8, right: 8, bgcolor: "#f8fafc" }}>
//             <Close fontSize="small" />
//           </IconButton>
//           <Box
//             sx={{
//               width: 52, height: 52, borderRadius: "50%", mx: "auto", mb: 1,
//               display: "flex", alignItems: "center", justifyContent: "center",
//               background: qrDialog.type === "UPI"
//                 ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
//                 : "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
//               color: "#fff",
//             }}
//           >
//             <QrCode2 sx={{ fontSize: 28 }} />
//           </Box>
//           <Typography sx={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
//             {qrDialog.type === "UPI" ? "UPI Payment" : "PhonePe Payment"}
//           </Typography>
//           <Typography sx={{ fontSize: 12, color: "#64748b", mt: 0.25 }}>{qrDialog.restaurant?.restaurantName}</Typography>
//         </DialogTitle>

//         <DialogContent sx={{ textAlign: "center", pb: 3 }}>
//           {qrDialog.restaurant && getActiveUpiId() ? (
//             <>
//               <Box sx={{ p: 2, bgcolor: "#fff", borderRadius: 3, border: "2px dashed #e2e8f0", display: "inline-block", mb: 2, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
//                 <img
//                   src={generateQRUrl(generateUPILink(getActiveUpiId(), qrDialog.restaurant.restaurantName))}
//                   alt="QR Code"
//                   style={{ width: 220, height: 220, display: "block" }}
//                 />
//               </Box>

//               <Box sx={{ bgcolor: "#f8fafc", borderRadius: 2, p: 1.5, mb: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
//                 <Box textAlign="left" flex={1} minWidth={0}>
//                   <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>UPI ID</Typography>
//                   <Typography sx={{ fontSize: 13, fontWeight: 800, fontFamily: "monospace", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "#0f172a" }}>
//                     {getActiveUpiId()}
//                   </Typography>
//                 </Box>
//                 <IconButton size="small" onClick={handleCopyUpi} sx={{ bgcolor: "#FFF4EC", color: BRAND.primary, "&:hover": { bgcolor: "#FFE8D6" } }}>
//                   <ContentCopy fontSize="small" />
//                 </IconButton>
//               </Box>

//               <Typography variant="caption" sx={{ color: "#94a3b8", display: "block", mb: 2, fontSize: 11 }}>
//                 Scan with GPay, PhonePe, Paytm or any UPI app
//               </Typography>

//               <Button
//                 fullWidth variant="contained" startIcon={<QrCode2 />}
//                 onClick={() => { window.location.href = generateUPILink(getActiveUpiId(), qrDialog.restaurant.restaurantName); }}
//                 sx={{
//                   py: 1.2, fontWeight: 800, textTransform: "none", borderRadius: 2,
//                   background: qrDialog.type === "UPI"
//                     ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
//                     : "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
//                   "&:hover": {
//                     background: qrDialog.type === "UPI"
//                       ? "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)"
//                       : "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
//                   },
//                 }}
//               >
//                 Open in {qrDialog.type === "UPI" ? "UPI App" : "PhonePe"}
//               </Button>
//             </>
//           ) : (
//             <Box py={3}>
//               <Typography variant="body2" color="text.secondary">Payment details not available for this restaurant.</Typography>
//             </Box>
//           )}
//         </DialogContent>
//       </Dialog>

//       {/* ══════════════ BOTTOM NAV ══════════════ */}
//       <Paper
//         sx={{ position: "fixed", bottom: 0, left: 0, right: 0, maxWidth: 550, mx: "auto", zIndex: 1000, borderTop: "1px solid #f1f5f9", bgcolor: "#fff" }}
//         elevation={0}
//       >
//         <BottomNavigation
//           showLabels
//           value={navTab}
//           onChange={(e, val) => setNavTab(val)}
//           sx={{
//             height: 64, bgcolor: "#fff",
//             "& .MuiBottomNavigationAction-root": { minWidth: 0, color: "#94a3b8", transition: "color 0.2s" },
//             "& .Mui-selected": { color: `${BRAND.primary} !important` },
//             "& .MuiBottomNavigationAction-label": { fontSize: 10, fontWeight: 600 },
//             "& .MuiBottomNavigationAction-label.Mui-selected": { fontSize: 10, fontWeight: 800 },
//           }}
//         >
//           <BottomNavigationAction
//             label="Orders"
//             icon={
//               <Badge badgeContent={counts.MY_ORDERS} color="error" sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 16, minWidth: 16 } }}>
//                 <Moped />
//               </Badge>
//             }
//           />
//           <BottomNavigationAction label="Hotels" icon={<Storefront />} />
//           <BottomNavigationAction
//             label="Earnings"
//             icon={
//               <Badge
//                 badgeContent={myCodOrders.filter((o) => ["UNSETTLED", "REJECTED"].includes(o.codSettlement?.status || "UNSETTLED")).length}
//                 color="error"
//                 sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 16, minWidth: 16 } }}
//               >
//                 <AccountBalanceWallet />
//               </Badge>
//             }
//           />
//           <BottomNavigationAction label="Profile" icon={<Person />} />
//         </BottomNavigation>
//       </Paper>
//     </Box>
//   );
// }

// // 🎨 Shared TextField styles
// const textFieldSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: 2, bgcolor: "#f8fafc", transition: "all 0.2s", fontSize: 13,
//     "&:hover": { bgcolor: "#fff" },
//     "& fieldset": { borderColor: "#e2e8f0" },
//     "&:hover fieldset": { borderColor: "#cbd5e1" },
//     "&.Mui-focused": { bgcolor: "#fff" },
//     "&.Mui-focused fieldset": { borderColor: BRAND.primary, borderWidth: 1.5 },
//   },
//   "& .MuiInputLabel-root": { fontSize: 13 },
//   "& .MuiInputLabel-root.Mui-focused": { color: BRAND.primaryDark },
// };

import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  Button,
  Divider,
  TextField,
  Avatar,
  IconButton,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Slide,
  Badge,
  Stack,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import {
  Moped,
  Storefront,
  AccountBalanceWallet,
  Person,
  Call,
  Navigation,
  Close,
  VolumeUp,
  TouchApp,
  CheckCircle,
  LocationOn,
  Schedule,
  Phone,
  QrCode2,
  ContentCopy,
  CameraAlt,
  Refresh,
  Payment,
  LocalDining,
  Receipt,
  Warning,
  Logout as LogoutIcon,
  Home,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import io from "socket.io-client";
import axiosInstance from "../../utils/axios";
import { toast } from "react-toastify";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BRAND = {
  primary: "#FF6B00",
  primaryDark: "#E85A00",
  gradient: "linear-gradient(135deg, #FF6B00 0%, #E85A00 100%)",
};

const PAGE_LIMIT = 20;

// 📅 Date/time formatters
const formatOrderDateTime = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const orderDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.floor((today - orderDay) / (1000 * 60 * 60 * 24));
  const time = date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });
  if (diffDays === 0) return `Today, ${time}`;
  if (diffDays === 1) return `Yesterday, ${time}`;
  const day = date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    timeZone: "Asia/Kolkata",
  });
  return `${day}, ${time}`;
};

const formatFullDateTime = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });
};

// 🔗 UPI helpers
const generateUPILink = (upiId, name, amount = "") => {
  if (!upiId) return "";
  const params = new URLSearchParams({
    pa: upiId,
    pn: name || "Restaurant",
    cu: "INR",
  });
  if (amount) params.append("am", amount);
  return `upi://pay?${params.toString()}`;
};

const generateQRUrl = (data, size = 300) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(
    data
  )}&bgcolor=FFFFFF&color=1e293b&margin=8`;

const getPhonePeUPI = (number) => {
  if (!number) return null;
  const str = String(number).trim();
  if (str.includes("@")) return str;
  return `${str}@ybl`;
};

// 🎨 Status configs (COMPLETED added)
const ORDER_STATUS_CFG = {
  PENDING:          { color: "#f59e0b", bg: "#fef3c7", label: "Pending" },
  ACCEPTED:         { color: "#8b5cf6", bg: "#ede9fe", label: "Accepted" },
  PREPARING:        { color: "#f59e0b", bg: "#fef3c7", label: "Preparing" },
  COMPLETED:        { color: "#10b981", bg: "#d1fae5", label: "Ready for Pickup" },
  OUT_FOR_DELIVERY: { color: "#3b82f6", bg: "#dbeafe", label: "Out for Delivery" },
  DELIVERED:        { color: "#10b981", bg: "#d1fae5", label: "Delivered" },
  CANCELLED:        { color: "#ef4444", bg: "#fee2e2", label: "Cancelled" },
};

const COD_STATUS_CFG = {
  UNSETTLED:    { color: "#dc2626", bg: "#fee2e2", label: "To Deposit",  icon: <Warning fontSize="small" /> },
  REJECTED:     { color: "#dc2626", bg: "#fee2e2", label: "Rejected",    icon: <Warning fontSize="small" /> },
  UNDER_REVIEW: { color: "#d97706", bg: "#fef3c7", label: "In Review",   icon: <Schedule fontSize="small" /> },
  PAID:         { color: "#059669", bg: "#d1fae5", label: "Paid",        icon: <CheckCircle fontSize="small" /> },
};

export default function DeliveryDashboard() {
  const navigate = useNavigate();
  const [navTab, setNavTab] = useState(0);
  const [orderFilter, setOrderFilter] = useState("AVAILABLE");
  const [profile, setProfile] = useState({});
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [socketConnected, setSocketConnected] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const socketRef = useRef(null);

  // 📄 Orders pagination
  const [ordersPage, setOrdersPage] = useState(1);
  const [ordersHasMore, setOrdersHasMore] = useState(true);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [ordersInitialLoading, setOrdersInitialLoading] = useState(true);
  const [counts, setCounts] = useState({ AVAILABLE: 0, MY_ORDERS: 0, DELIVERED: 0 });

  // 🏨 Restaurants pagination
  const [restaurants, setRestaurants] = useState([]);
  const [restPage, setRestPage] = useState(1);
  const [restHasMore, setRestHasMore] = useState(true);
  const [restLoading, setRestLoading] = useState(false);
  const [restInitialLoading, setRestInitialLoading] = useState(true);

  // 💰 COD orders
  const [codOrders, setCodOrders] = useState([]);

  // Refs for socket closures
  const orderFilterRef = useRef(orderFilter);
  useEffect(() => { orderFilterRef.current = orderFilter; }, [orderFilter]);

  // Infinite scroll sentinels
  const ordersLoadMoreRef = useRef(null);
  const restLoadMoreRef = useRef(null);

  const [qrDialog, setQrDialog] = useState({ open: false, type: null, restaurant: null });

  const [profileForm, setProfileForm] = useState({
    name: "", phone: "", address: "", vehicleType: "Bike", vehicleNumber: "",
  });
  const [newProfileImage, setNewProfileImage] = useState(null);
  const [passwordForm, setPasswordForm] = useState({ currentPassword: "", newPassword: "" });
  const [savingProfile, setSavingProfile] = useState(false);

  const playNotificationSound = () => {
    try {
      const audio = new Audio("/sounds/notification.mp3");
      audio.play().catch(() => {});
    } catch (e) {}
  };

  // ══════════════════════════════════════════════════════
  // FETCHERS
  // ══════════════════════════════════════════════════════
  const fetchProfile = async () => {
    try {
      const res = await axiosInstance.get("/api/delivery/profile");
      const user = res.data.deliveryBoy;
      setProfile(user);
      setProfileForm({
        name: user.name || "",
        phone: user.phone || "",
        address: user.address || "",
        vehicleType: user.vehicleType || "Bike",
        vehicleNumber: user.vehicleNumber || "",
      });
    } catch (err) {
      if (err.response?.status === 401) navigate("/delivery/login");
    }
  };

  const fetchOrders = async (type, pageNum, append = false) => {
    if (append) setOrdersLoading(true);
    else setOrdersInitialLoading(true);
    try {
      const res = await axiosInstance.get("/api/delivery/orders", {
        params: { page: pageNum, limit: PAGE_LIMIT, type },
      });
      const items = res.data.orders || [];
      setOrders((prev) => (append ? [...prev, ...items] : items));
      setOrdersHasMore(res.data.pagination?.hasNextPage ?? false);
    } catch (err) {
      if (err.response?.status === 401) navigate("/delivery/login");
    } finally {
      setOrdersLoading(false);
      setOrdersInitialLoading(false);
    }
  };

  const fetchCounts = async () => {
    try {
      const [a, b, c] = await Promise.all([
        axiosInstance.get("/api/delivery/orders", { params: { type: "AVAILABLE", limit: 1 } }),
        axiosInstance.get("/api/delivery/orders", { params: { type: "MY_ORDERS", limit: 1 } }),
        axiosInstance.get("/api/delivery/orders", { params: { type: "DELIVERED", limit: 1 } }),
      ]);
      setCounts({
        AVAILABLE: a.data.pagination?.total || 0,
        MY_ORDERS: b.data.pagination?.total || 0,
        DELIVERED: c.data.pagination?.total || 0,
      });
    } catch (err) {}
  };

  const fetchRestaurants = async (pageNum, append = false) => {
    if (append) setRestLoading(true);
    else setRestInitialLoading(true);
    try {
      const res = await axiosInstance.get("/api/delivery/restaurants", {
        params: { page: pageNum, limit: PAGE_LIMIT },
      });
      const items = res.data.restaurants || [];
      setRestaurants((prev) => (append ? [...prev, ...items] : items));
      setRestHasMore(res.data.pagination?.hasNextPage ?? false);
    } catch (err) {
    } finally {
      setRestLoading(false);
      setRestInitialLoading(false);
    }
  };

  const fetchCodOrders = async () => {
    try {
      const res = await axiosInstance.get("/api/delivery/orders", {
        params: { type: "DELIVERED", limit: 100 },
      });
      setCodOrders(res.data.orders || []);
    } catch (err) {}
  };

  const fetchAll = async () => {
    await Promise.all([
      fetchProfile(),
      fetchRestaurants(1, false),
      fetchOrders(orderFilter, 1, false),
      fetchCounts(),
      fetchCodOrders(),
    ]);
  };

  const handleManualRefresh = async () => {
    setRefreshing(true);
    await fetchAll();
    setRefreshing(false);
    toast.success("Data refreshed");
  };

  // ══════════════════════════════════════════════════════
  // MOUNT + SOCKET
  // ══════════════════════════════════════════════════════
  useEffect(() => {
    fetchAll();

    const baseURL = axiosInstance.defaults.baseURL || "http://localhost:8000";
    const socket = io(baseURL.replace(/\/$/, ""), {
      withCredentials: true,
      transports: ["websocket", "polling"],
      reconnection: true,
    });
    socketRef.current = socket;

    socket.on("connect", () => {
      setSocketConnected(true);
      const deliveryUser = JSON.parse(localStorage.getItem("deliveryUser") || "{}");
      if (deliveryUser.city) {
        socket.emit("delivery-join", {
          deliveryBoyId: deliveryUser._id || deliveryUser.id,
          city: deliveryUser.city,
          name: deliveryUser.name,
        });
      }
    });

    socket.on("disconnect", () => setSocketConnected(false));

    socket.on("delivery-new-order", (data) => {
      playNotificationSound();
      toast.info(`🔔 New Order from ${data.order?.restaurant?.restaurantName || "Hotel"}!`);
      if (orderFilterRef.current === "AVAILABLE") {
        setOrders((prev) => [data.order, ...prev.filter((o) => o._id !== data.order._id)]);
      }
      setCounts((prev) => ({ ...prev, AVAILABLE: prev.AVAILABLE + 1 }));
    });

    socket.on("order-claimed-by-rider", ({ orderId, claimedBy }) => {
      const myId = profile._id;
      if (claimedBy !== myId) {
        setOrders((prev) => prev.filter((o) => o._id !== orderId));
        if (selectedOrder?._id === orderId) {
          setDetailsOpen(false);
          setSelectedOrder(null);
          toast.info("This order was accepted by another rider.");
        }
        setCounts((prev) => ({ ...prev, AVAILABLE: Math.max(0, prev.AVAILABLE - 1) }));
      }
    });

    // 🔥 Order status update (from Hotel or self) — full order spread for all changes
    socket.on("delivery-order-updated", (data) => {
      setOrders((prev) =>
        prev.map((o) =>
          o._id === data.order._id ? { ...o, ...data.order, status: data.order.status } : o
        )
      );
      if (selectedOrder?._id === data.order._id) {
        setSelectedOrder((prev) => ({ ...prev, ...data.order, status: data.order.status }));
      }
    });

    socket.on("cod-settlement-updated", ({ order: updatedOrder, message, status }) => {
      if (message) {
        status === "PAID" ? toast.success(message) : toast.error(message);
      }
      setOrders((prev) =>
        prev.map((o) => (o._id === updatedOrder._id ? updatedOrder : o))
      );
      setCodOrders((prev) =>
        prev.map((o) => (o._id === updatedOrder._id ? updatedOrder : o))
      );
    });

    return () => socket.disconnect();
    // eslint-disable-next-line
  }, [profile._id, selectedOrder]);

  // Filter change → reset & fetch
  useEffect(() => {
    setOrdersPage(1);
    setOrders([]);
    setOrdersHasMore(true);
    fetchOrders(orderFilter, 1, false);
  }, [orderFilter]);

  // Infinite scroll — orders
  useEffect(() => {
    if (navTab !== 0) return;
    const el = ordersLoadMoreRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          ordersHasMore &&
          !ordersLoading &&
          !ordersInitialLoading
        ) {
          const nextPage = ordersPage + 1;
          setOrdersPage(nextPage);
          fetchOrders(orderFilter, nextPage, true);
        }
      },
      { threshold: 0.1, rootMargin: "200px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [ordersHasMore, ordersLoading, ordersInitialLoading, ordersPage, orderFilter, navTab]);

  // Infinite scroll — restaurants
  useEffect(() => {
    if (navTab !== 1) return;
    const el = restLoadMoreRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          restHasMore &&
          !restLoading &&
          !restInitialLoading
        ) {
          const nextPage = restPage + 1;
          setRestPage(nextPage);
          fetchRestaurants(nextPage, true);
        }
      },
      { threshold: 0.1, rootMargin: "200px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [restHasMore, restLoading, restInitialLoading, restPage, navTab]);

  // ══════════════════════════════════════════════════════
  // ACTIONS
  // ══════════════════════════════════════════════════════
  const handleAcceptOrder = async (orderId, e) => {
    if (e) e.stopPropagation();
    try {
      const res = await axiosInstance.put(`/api/delivery/orders/${orderId}/accept`);
      toast.success("Order Accepted! Assigned to you.");
      setCounts((prev) => ({
        ...prev,
        AVAILABLE: Math.max(0, prev.AVAILABLE - 1),
        MY_ORDERS: prev.MY_ORDERS + 1,
      }));
      if (selectedOrder?._id === orderId) setSelectedOrder(res.data.order);
      setOrderFilter("MY_ORDERS");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to accept order");
      fetchCounts();
    }
  };

  const handleUpdateStatus = async (orderId, newStatus) => {
    try {
      const res = await axiosInstance.put(`/api/delivery/orders/${orderId}/status`, {
        status: newStatus,
      });
      toast.success(`Order status: ${newStatus}`);
      const updated = res.data.order;
      if (selectedOrder?._id === orderId) setSelectedOrder(updated);

      if (orderFilter === "MY_ORDERS" && newStatus === "DELIVERED") {
        setOrders((prev) => prev.filter((o) => o._id !== orderId));
        setCounts((prev) => ({
          ...prev,
          MY_ORDERS: Math.max(0, prev.MY_ORDERS - 1),
          DELIVERED: prev.DELIVERED + 1,
        }));
        if (updated.paymentMethod === "CASH") {
          setCodOrders((prev) => [updated, ...prev]);
        }
      } else {
        setOrders((prev) => prev.map((o) => (o._id === orderId ? updated : o)));
        setCodOrders((prev) => prev.map((o) => (o._id === orderId ? updated : o)));
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update status");
    }
  };

  const handlePayToRestaurant = async (orderId) => {
    try {
      const res = await axiosInstance.put(`/api/delivery/orders/${orderId}/pay-to-restaurant`);
      toast.info("Request sent! Status is now Under Review.");
      setOrders((prev) => prev.map((o) => (o._id === orderId ? res.data.order : o)));
      setCodOrders((prev) => prev.map((o) => (o._id === orderId ? res.data.order : o)));
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send request");
    }
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    setSavingProfile(true);
    try {
      const data = new FormData();
      Object.keys(profileForm).forEach((key) => data.append(key, profileForm[key]));
      if (newProfileImage) data.append("profileImage", newProfileImage);
      const res = await axiosInstance.put("/api/delivery/profile/update", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setProfile(res.data.deliveryBoy);
      setNewProfileImage(null);
      toast.success("Profile updated successfully!");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update profile");
    } finally {
      setSavingProfile(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.put("/api/delivery/profile/password", passwordForm);
      toast.success("Password changed successfully!");
      setPasswordForm({ currentPassword: "", newPassword: "" });
    } catch (err) {
      toast.error(err.response?.data?.message || "Password change failed");
    }
  };

  const handleLogout = () => {
    if (socketRef.current) socketRef.current.disconnect();
    localStorage.removeItem("deliveryUser");
    navigate("/delivery/login");
  };

  // Derived
  const myId = profile._id;
  const myCodOrders = codOrders.filter((o) => o.paymentMethod === "CASH");
  const pendingCodAmount = myCodOrders
    .filter((o) => !o.codSettlement?.status || ["UNSETTLED", "REJECTED"].includes(o.codSettlement?.status))
    .reduce((sum, o) => sum + (o.orderSummary?.totalAmount || 0), 0);
  const underReviewCodAmount = myCodOrders
    .filter((o) => o.codSettlement?.status === "UNDER_REVIEW")
    .reduce((sum, o) => sum + (o.orderSummary?.totalAmount || 0), 0);
  const settledCodAmount = myCodOrders
    .filter((o) => o.codSettlement?.status === "PAID")
    .reduce((sum, o) => sum + (o.orderSummary?.totalAmount || 0), 0);

  // QR helpers
  const openQRDialog = (restaurant, type) => setQrDialog({ open: true, type, restaurant });
  const closeQRDialog = () => setQrDialog({ open: false, type: null, restaurant: null });
  const getActiveUpiId = () => {
    if (!qrDialog.restaurant) return "";
    if (qrDialog.type === "UPI") return qrDialog.restaurant.payment?.upiId;
    return getPhonePeUPI(qrDialog.restaurant.payment?.phonePeNumber);
  };
  const handleCopyUpi = async () => {
    const id = getActiveUpiId();
    if (!id) return;
    try {
      await navigator.clipboard.writeText(id);
      toast.success("UPI ID copied!");
    } catch {
      toast.error("Copy failed");
    }
  };

  // Helper to check if order belongs to me
  const isMyOrder = (order) =>
    order?.deliveryBoy === myId || order?.deliveryBoy?._id === myId;

  return (
    <Box sx={{ maxWidth: 550, mx: "auto", minHeight: "100vh", bgcolor: "#f8fafc", pb: 10 }}>
      {/* ══════════════ HEADER ══════════════ */}
      <Box
        sx={{
          bgcolor: "#fff",
          px: 2,
          py: 1.75,
          position: "sticky",
          top: 0,
          zIndex: 100,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
          borderBottom: "1px solid #f1f5f9",
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5} minWidth={0} flex={1}>
          <Box position="relative">
            <Avatar
              src={profile.profileImage?.url}
              alt={profile.name}
              sx={{
                width: 46,
                height: 46,
                border: `2px solid ${BRAND.primary}`,
                fontSize: 18,
                fontWeight: 700,
              }}
            >
              {profile.name?.[0]?.toUpperCase()}
            </Avatar>
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                right: 0,
                width: 13,
                height: 13,
                borderRadius: "50%",
                bgcolor: socketConnected ? "#10b981" : "#94a3b8",
                border: "2px solid #fff",
                boxShadow: socketConnected ? "0 0 0 3px rgba(16,185,129,0.25)" : "none",
              }}
            />
          </Box>
          <Box minWidth={0} flex={1}>
            <Typography variant="subtitle1" fontWeight={700} lineHeight={1.15} noWrap sx={{ fontSize: 15 }}>
              {profile.name || "Delivery Partner"}
            </Typography>
            <Box display="flex" alignItems="center" gap={0.75} mt={0.4}>
              <Chip
                icon={<LocationOn sx={{ fontSize: "12px !important", color: `${BRAND.primaryDark} !important` }} />}
                label={profile.city?.toUpperCase() || "N/A"}
                size="small"
                sx={{
                  height: 20,
                  fontSize: 10,
                  bgcolor: "#FFF4EC",
                  color: BRAND.primaryDark,
                  fontWeight: 700,
                  "& .MuiChip-label": { px: 0.75 },
                }}
              />
              <Typography variant="caption" sx={{ color: "#94a3b8", fontSize: 10 }}>
                {socketConnected ? "Live" : "Offline"}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box display="flex" gap={0.75} alignItems="center">
          <Tooltip title="Refresh">
            <IconButton
              size="small"
              onClick={handleManualRefresh}
              disabled={refreshing}
              sx={{ bgcolor: "#f8fafc", color: "#64748b", "&:hover": { bgcolor: "#f1f5f9" } }}
            >
              <Refresh
                fontSize="small"
                sx={{ animation: refreshing ? "spin 1s linear infinite" : "none", "@keyframes spin": { "100%": { transform: "rotate(360deg)" } } }}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Test sound">
            <IconButton
              size="small"
              onClick={playNotificationSound}
              sx={{ bgcolor: "#f8fafc", color: "#64748b", "&:hover": { bgcolor: "#f1f5f9" } }}
            >
              <VolumeUp fontSize="small" />
            </IconButton>
          </Tooltip>
          <Button
            size="small"
            startIcon={<LogoutIcon sx={{ fontSize: 16 }} />}
            onClick={handleLogout}
            sx={{
              color: "#dc2626",
              fontSize: 12,
              fontWeight: 700,
              textTransform: "none",
              minWidth: "auto",
              px: 1.25,
              py: 0.5,
              borderRadius: 2,
              "&:hover": { bgcolor: "#fee2e2" },
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>

      {/* ══════════════ TAB 0: ORDERS ══════════════ */}
      {navTab === 0 && (
        <Box p={2}>
          <Box display="flex" gap={1} mb={2} overflow="auto" sx={{ "&::-webkit-scrollbar": { display: "none" } }}>
            <Chip
              label={`New (${counts.AVAILABLE})`}
              onClick={() => setOrderFilter("AVAILABLE")}
              sx={{
                fontWeight: 700, fontSize: 12, height: 32,
                bgcolor: orderFilter === "AVAILABLE" ? BRAND.primary : "#fff",
                color: orderFilter === "AVAILABLE" ? "#fff" : "#64748b",
                border: "1px solid", borderColor: orderFilter === "AVAILABLE" ? BRAND.primary : "#e2e8f0",
                "&:hover": { bgcolor: orderFilter === "AVAILABLE" ? BRAND.primaryDark : "#f8fafc" },
              }}
            />
            <Chip
              label={`Active (${counts.MY_ORDERS})`}
              onClick={() => setOrderFilter("MY_ORDERS")}
              sx={{
                fontWeight: 700, fontSize: 12, height: 32,
                bgcolor: orderFilter === "MY_ORDERS" ? "#f59e0b" : "#fff",
                color: orderFilter === "MY_ORDERS" ? "#fff" : "#64748b",
                border: "1px solid", borderColor: orderFilter === "MY_ORDERS" ? "#f59e0b" : "#e2e8f0",
                "&:hover": { bgcolor: orderFilter === "MY_ORDERS" ? "#d97706" : "#f8fafc" },
              }}
            />
            <Chip
              label={`Delivered (${counts.DELIVERED})`}
              onClick={() => setOrderFilter("DELIVERED")}
              sx={{
                fontWeight: 700, fontSize: 12, height: 32,
                bgcolor: orderFilter === "DELIVERED" ? "#10b981" : "#fff",
                color: orderFilter === "DELIVERED" ? "#fff" : "#64748b",
                border: "1px solid", borderColor: orderFilter === "DELIVERED" ? "#10b981" : "#e2e8f0",
                "&:hover": { bgcolor: orderFilter === "DELIVERED" ? "#059669" : "#f8fafc" },
              }}
            />
          </Box>

          {ordersInitialLoading && orders.length === 0 && (
            <Box display="flex" justifyContent="center" py={8}>
              <CircularProgress sx={{ color: BRAND.primary }} />
            </Box>
          )}

          {orders.map((order) => {
            const isAssignedToMe = isMyOrder(order);
            const isUnassigned = !order.deliveryBoy;
            const isCash = order.paymentMethod === "CASH";
            const cfg = ORDER_STATUS_CFG[order.status] || ORDER_STATUS_CFG.PENDING;

            return (
              <Card
                key={order._id}
                onClick={() => { setSelectedOrder(order); setDetailsOpen(true); }}
                elevation={0}
                sx={{
                  mb: 1.75, borderRadius: 3, border: "1px solid #f1f5f9",
                  position: "relative", overflow: "hidden", cursor: "pointer",
                  transition: "all 0.2s",
                  "&:hover": { boxShadow: "0 6px 20px rgba(0,0,0,0.06)", transform: "translateY(-2px)" },
                }}
              >
                <Box sx={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 4, bgcolor: cfg.color }} />
                <CardContent sx={{ pl: 2.5, p: 2, "&:last-child": { pb: 2 } }}>
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.25}>
                    <Box>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Order</Typography>
                      <Typography sx={{ fontSize: 15, fontWeight: 800, fontFamily: "monospace", color: "#0f172a", lineHeight: 1.2 }}>
                        #{order._id.slice(-6).toUpperCase()}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.25 }}>🕒 {formatOrderDateTime(order.createdAt)}</Typography>
                    </Box>
                    <Chip label={cfg.label} size="small" sx={{ bgcolor: cfg.bg, color: cfg.color, fontWeight: 700, fontSize: 10, height: 22 }} />
                  </Box>

                  <Box display="flex" alignItems="flex-start" gap={1} mb={1}>
                    <LocalDining sx={{ fontSize: 16, color: BRAND.primary, mt: 0.2, flexShrink: 0 }} />
                    <Box flex={1} minWidth={0}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3 }}>{order.restaurant?.restaurantName}</Typography>
                      <Typography sx={{ fontSize: 11, color: "#64748b", lineHeight: 1.3 }}>
                        {order.restaurant?.restaurantAddress || order.restaurant?.address || "—"}
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" alignItems="flex-start" gap={1} mb={1.5}>
                    <Person sx={{ fontSize: 16, color: "#3b82f6", mt: 0.2, flexShrink: 0 }} />
                    <Box flex={1} minWidth={0}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3 }}>
                        {order.customer?.name} {order.customer?.phone && <span style={{ color: "#64748b", fontWeight: 500 }}>• {order.customer.phone}</span>}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: "#64748b", lineHeight: 1.3 }}>{order.customer?.address || "Address not provided"}</Typography>
                    </Box>
                  </Box>

                  <Divider sx={{ mb: 1.5, borderColor: "#f1f5f9" }} />

                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>Amount</Typography>
                      <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#0f172a", lineHeight: 1.1 }}>₹{order.orderSummary?.totalAmount || 0}</Typography>
                      <Typography sx={{ fontSize: 10, color: isCash ? "#dc2626" : "#16a34a", fontWeight: 700 }}>
                        {isCash ? "Collect Cash" : "Paid Online"}
                      </Typography>
                    </Box>

                    {isUnassigned && (
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<TouchApp sx={{ fontSize: 16 }} />}
                        onClick={(e) => handleAcceptOrder(order._id, e)}
                        sx={{
                          borderRadius: 2, textTransform: "none", fontWeight: 700, fontSize: 12,
                          bgcolor: BRAND.primary, "&:hover": { bgcolor: BRAND.primaryDark },
                          boxShadow: "0 4px 12px rgba(255,107,0,0.25)",
                        }}
                      >
                        Accept
                      </Button>
                    )}

                    {isAssignedToMe && order.status !== "DELIVERED" && (
                      <Chip icon={<CheckCircle sx={{ fontSize: "14px !important" }} />} label="Assigned" size="small" sx={{ bgcolor: "#fef3c7", color: "#d97706", fontWeight: 700, fontSize: 10, height: 24 }} />
                    )}

                    {order.status === "DELIVERED" && (
                      <Chip icon={<CheckCircle sx={{ fontSize: "14px !important" }} />} label="Completed" size="small" sx={{ bgcolor: "#d1fae5", color: "#059669", fontWeight: 700, fontSize: 10, height: 24 }} />
                    )}
                  </Box>
                </CardContent>
              </Card>
            );
          })}

          {orders.length > 0 && (
            <Box ref={ordersLoadMoreRef} display="flex" justifyContent="center" py={2}>
              {ordersLoading && <CircularProgress size={24} sx={{ color: BRAND.primary }} />}
              {!ordersHasMore && !ordersLoading && (
                <Typography variant="caption" sx={{ color: "#94a3b8", fontSize: 11 }}>
                  — No more orders —
                </Typography>
              )}
            </Box>
          )}

          {!ordersInitialLoading && orders.length === 0 && (
            <Box textAlign="center" py={10}>
              <Box sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                <Moped sx={{ fontSize: 40, color: "#cbd5e1" }} />
              </Box>
              <Typography sx={{ fontWeight: 700, color: "#475569", mb: 0.5 }}>
                {orderFilter === "AVAILABLE" ? "No new orders" : orderFilter === "MY_ORDERS" ? "No active orders" : "No delivered orders yet"}
              </Typography>
              <Typography variant="caption" sx={{ color: "#94a3b8", maxWidth: 260, display: "inline-block" }}>
                {orderFilter === "AVAILABLE" ? "New delivery orders will appear here automatically." : orderFilter === "MY_ORDERS" ? "Accept an order from the New tab to see it here." : "Your delivered orders will be listed here."}
              </Typography>
            </Box>
          )}
        </Box>
      )}

      {/* ══════════════ TAB 1: HOTELS ══════════════ */}
      {navTab === 1 && (
        <Box p={2}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Box>
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Restaurants</Typography>
              <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0f172a" }}>Active Partners</Typography>
            </Box>
            <Chip label={`${restaurants.length}${restHasMore ? "+" : ""}`} size="small" sx={{ bgcolor: BRAND.primary, color: "#fff", fontWeight: 800, minWidth: 32 }} />
          </Box>

          {restInitialLoading && restaurants.length === 0 && (
            <Box display="flex" justifyContent="center" py={8}>
              <CircularProgress sx={{ color: BRAND.primary }} />
            </Box>
          )}

          {restaurants.map((rest) => {
            const hasUpi = rest.payment?.upiEnabled && rest.payment?.upiId;
            const hasPhonePe = rest.payment?.phonePeEnabled && rest.payment?.phonePeNumber;
            const hasAnyPayment = rest.payment?.cashEnabled || hasUpi || hasPhonePe;

            return (
              <Card
                key={rest._id}
                elevation={0}
                sx={{
                  mb: 2, borderRadius: 3, overflow: "hidden",
                  border: "1px solid #f1f5f9",
                  transition: "all 0.2s",
                  "&:hover": { boxShadow: "0 8px 24px rgba(255,107,0,0.08)", transform: "translateY(-2px)" },
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    background: "linear-gradient(135deg, #FFF9F5 0%, #FFFFFF 100%)",
                    borderBottom: "1px solid #f1f5f9",
                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: -30, right: -30,
                      width: 100, height: 100,
                      borderRadius: "50%",
                      bgcolor: "rgba(255,107,0,0.06)",
                      pointerEvents: "none",
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1.5} position="relative" zIndex={1}>
                    <Avatar
                      sx={{
                        width: 52, height: 52,
                        background: BRAND.gradient,
                        fontWeight: 800, fontSize: 22,
                        boxShadow: "0 4px 12px rgba(255,107,0,0.25)",
                        border: "2px solid #fff",
                      }}
                    >
                      {rest.restaurantName?.[0]?.toUpperCase() || "R"}
                    </Avatar>
                    <Box flex={1} minWidth={0}>
                      <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#0f172a", lineHeight: 1.2, mb: 0.5 }} noWrap>
                        {rest.restaurantName}
                      </Typography>
                      <Box display="flex" alignItems="center" gap={0.75} flexWrap="wrap">
                        <Chip
                          icon={<CheckCircle sx={{ fontSize: "11px !important" }} />}
                          label="Delivery Active"
                          size="small"
                          sx={{
                            height: 20, fontSize: 9.5,
                            bgcolor: "#d1fae5", color: "#059669", fontWeight: 700,
                            "& .MuiChip-icon": { color: "#059669" },
                            "& .MuiChip-label": { px: 0.75 },
                          }}
                        />
                        {rest.city && (
                          <Typography sx={{ fontSize: 10.5, color: "#94a3b8", fontWeight: 600 }}>
                            📍 {rest.city}{rest.state ? `, ${rest.state}` : ""}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                  <Stack spacing={1.25} mb={hasAnyPayment ? 1.5 : 0}>
                    <Box display="flex" gap={1.25}>
                      <Box
                        sx={{
                          width: 28, height: 28, borderRadius: 1.5,
                          bgcolor: "#FFF4EC",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <LocationOn sx={{ fontSize: 15, color: BRAND.primary }} />
                      </Box>
                      <Box flex={1} minWidth={0}>
                        <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", lineHeight: 1 }}>
                          Address
                        </Typography>
                        <Typography sx={{ fontSize: 12, color: "#334155", lineHeight: 1.4, mt: 0.25 }}>
                          {rest.restaurantAddress || rest.address || "—"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box display="flex" gap={1.25}>
                      <Box
                        sx={{
                          width: 28, height: 28, borderRadius: 1.5,
                          bgcolor: "#dbeafe",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <Schedule sx={{ fontSize: 15, color: "#2563eb" }} />
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", lineHeight: 1 }}>
                          Timings
                        </Typography>
                        <Typography sx={{ fontSize: 12, color: "#334155", fontWeight: 600, mt: 0.25 }}>
                          {rest.openingTime || "—"} – {rest.closingTime || "—"}
                        </Typography>
                      </Box>
                    </Box>

                    {(rest.mobile || rest.whatsappNumber) && (
                      <Box
                        display="flex" gap={1.25}
                        component="a"
                        href={`tel:${rest.mobile || rest.whatsappNumber}`}
                        sx={{ textDecoration: "none", color: "inherit" }}
                      >
                        <Box
                          sx={{
                            width: 28, height: 28, borderRadius: 1.5,
                            bgcolor: "#d1fae5",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <Phone sx={{ fontSize: 15, color: "#059669" }} />
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", lineHeight: 1 }}>
                            Contact
                          </Typography>
                          <Typography sx={{ fontSize: 12, color: BRAND.primaryDark, fontWeight: 700, mt: 0.25 }}>
                            {rest.mobile || rest.whatsappNumber}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Stack>

                  {hasAnyPayment && <Divider sx={{ my: 1.5, borderColor: "#f1f5f9" }} />}

                  {hasAnyPayment && (
                    <>
                      <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, mb: 1 }}>
                        PAYMENT METHODS
                      </Typography>
                      <Box display="flex" gap={0.75} flexWrap="wrap" mb={2}>
                        {rest.payment?.cashEnabled && (
                          <Chip label="💵 Cash" size="small" sx={{ bgcolor: "#ecfdf5", color: "#059669", fontWeight: 700, fontSize: 10, height: 22 }} />
                        )}
                        {hasUpi && (
                          <Chip label="📱 UPI" size="small" sx={{ bgcolor: "#eff6ff", color: "#2563eb", fontWeight: 700, fontSize: 10, height: 22 }} />
                        )}
                        {hasPhonePe && (
                          <Chip label="💜 PhonePe" size="small" sx={{ bgcolor: "#f5f3ff", color: "#7c3aed", fontWeight: 700, fontSize: 10, height: 22 }} />
                        )}
                      </Box>
                    </>
                  )}

                  <Box display="flex" gap={1}>
                    {hasUpi && (
                      <Button
                        fullWidth
                        variant="contained"
                        size="small"
                        startIcon={<QrCode2 sx={{ fontSize: 16 }} />}
                        onClick={() => openQRDialog(rest, "UPI")}
                        sx={{
                          background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                          "&:hover": { background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)" },
                          fontWeight: 700, textTransform: "none",
                          borderRadius: 2, py: 0.85, fontSize: 11,
                          boxShadow: "0 4px 12px rgba(37,99,235,0.25)",
                        }}
                      >
                        UPI QR
                      </Button>
                    )}
                    {hasPhonePe && (
                      <Button
                        fullWidth
                        variant="contained"
                        size="small"
                        startIcon={<QrCode2 sx={{ fontSize: 16 }} />}
                        onClick={() => openQRDialog(rest, "PhonePe")}
                        sx={{
                          background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                          "&:hover": { background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)" },
                          fontWeight: 700, textTransform: "none",
                          borderRadius: 2, py: 0.85, fontSize: 11,
                          boxShadow: "0 4px 12px rgba(124,58,237,0.25)",
                        }}
                      >
                        PhonePe QR
                      </Button>
                    )}
                  </Box>
                </CardContent>
              </Card>
            );
          })}

          {restaurants.length > 0 && (
            <Box ref={restLoadMoreRef} display="flex" justifyContent="center" py={2}>
              {restLoading && <CircularProgress size={24} sx={{ color: BRAND.primary }} />}
              {!restHasMore && !restLoading && (
                <Typography variant="caption" sx={{ color: "#94a3b8", fontSize: 11 }}>
                  — No more restaurants —
                </Typography>
              )}
            </Box>
          )}

          {!restInitialLoading && restaurants.length === 0 && (
            <Box textAlign="center" py={10}>
              <Box sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                <Storefront sx={{ fontSize: 40, color: "#cbd5e1" }} />
              </Box>
              <Typography sx={{ fontWeight: 700, color: "#475569", mb: 0.5 }}>No restaurants yet</Typography>
              <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                Restaurants in {profile.city || "your city"} will appear here.
              </Typography>
            </Box>
          )}
        </Box>
      )}

      {/* ══════════════ TAB 2: EARNINGS ══════════════ */}
      {navTab === 2 && (
        <Box p={2}>
          <Grid container spacing={1.5} mb={2.5}>
            <Grid item xs={4}>
              <Card
                elevation={0}
                sx={{
                  p: 1.75, borderRadius: 3,
                  border: "1px solid #fecaca",
                  background: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",
                  textAlign: "center", height: "100%",
                }}
              >
                <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#dc2626", letterSpacing: 0.5, mb: 0.5 }}>TO DEPOSIT</Typography>
                <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#dc2626", lineHeight: 1.1 }}>₹{pendingCodAmount}</Typography>
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Card
                elevation={0}
                sx={{
                  p: 1.75, borderRadius: 3,
                  border: "1px solid #fde68a",
                  background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
                  textAlign: "center", height: "100%",
                }}
              >
                <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#d97706", letterSpacing: 0.5, mb: 0.5 }}>IN REVIEW</Typography>
                <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#d97706", lineHeight: 1.1 }}>₹{underReviewCodAmount}</Typography>
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Card
                elevation={0}
                sx={{
                  p: 1.75, borderRadius: 3,
                  border: "1px solid #bbf7d0",
                  background: "linear-gradient(135deg, #f0fdf4 0%, #d1fae5 100%)",
                  textAlign: "center", height: "100%",
                }}
              >
                <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#059669", letterSpacing: 0.5, mb: 0.5 }}>SETTLED</Typography>
                <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#059669", lineHeight: 1.1 }}>₹{settledCodAmount}</Typography>
              </Card>
            </Grid>
          </Grid>

          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
            <Box>
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Cash In Hand</Typography>
              <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#0f172a" }}>Order-wise Breakdown</Typography>
            </Box>
            <Chip label={`${myCodOrders.length} orders`} size="small" sx={{ bgcolor: "#f1f5f9", color: "#64748b", fontWeight: 700, fontSize: 10, height: 22 }} />
          </Box>

          {myCodOrders.map((order) => {
            const settlementStatus = order.codSettlement?.status || "UNSETTLED";
            const cfg = COD_STATUS_CFG[settlementStatus] || COD_STATUS_CFG.UNSETTLED;
            const isPaid = settlementStatus === "PAID";
            const isUnderReview = settlementStatus === "UNDER_REVIEW";
            const isActionable = ["UNSETTLED", "REJECTED"].includes(settlementStatus);

            return (
              <Card
                key={order._id}
                elevation={0}
                sx={{ mb: 1.75, borderRadius: 3, border: "1px solid #f1f5f9", overflow: "hidden", position: "relative" }}
              >
                <Box sx={{ height: 3, bgcolor: cfg.color }} />

                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.25}>
                    <Box>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Order</Typography>
                      <Typography sx={{ fontSize: 14, fontWeight: 800, fontFamily: "monospace", color: "#0f172a", lineHeight: 1.2 }}>
                        #{order._id.slice(-6).toUpperCase()}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.25 }}>🕒 {formatOrderDateTime(order.createdAt)}</Typography>
                    </Box>
                    <Chip
                      icon={cfg.icon}
                      label={cfg.label}
                      size="small"
                      sx={{
                        bgcolor: cfg.bg, color: cfg.color, fontWeight: 800, fontSize: 10, height: 24,
                        "& .MuiChip-icon": { color: `${cfg.color} !important`, ml: 0.75 },
                      }}
                    />
                  </Box>

                  <Box sx={{ p: 1.25, bgcolor: "#f8fafc", borderRadius: 2, border: "1px solid #f1f5f9", mb: 1.5 }}>
                    <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, mb: 0.5 }}>PAY TO RESTAURANT</Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar sx={{ width: 32, height: 32, bgcolor: "#FFF4EC", color: BRAND.primary, fontSize: 14, fontWeight: 800 }}>
                        {order.restaurant?.restaurantName?.[0]?.toUpperCase() || "R"}
                      </Avatar>
                      <Box flex={1} minWidth={0}>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3 }} noWrap>
                          {order.restaurant?.restaurantName || "Restaurant"}
                        </Typography>
                        <Typography sx={{ fontSize: 10.5, color: "#64748b", lineHeight: 1.3 }} noWrap>
                          {order.restaurant?.mobile || order.restaurant?.whatsappNumber || "—"}
                        </Typography>
                      </Box>
                      <IconButton
                        size="small"
                        href={`tel:${order.restaurant?.mobile || order.restaurant?.whatsappNumber || ""}`}
                        sx={{ bgcolor: "#fff", color: BRAND.primary, border: "1px solid #f1f5f9" }}
                      >
                        <Call sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Box>
                  </Box>

                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>COD Collected</Typography>
                      <Typography sx={{ fontSize: 20, fontWeight: 800, color: "#0f172a", lineHeight: 1.1 }}>
                        ₹{order.orderSummary?.totalAmount || 0}
                      </Typography>
                    </Box>

                    {isPaid && (
                      <Box display="flex" alignItems="center" gap={0.5} sx={{ color: "#059669" }}>
                        <CheckCircle sx={{ fontSize: 18 }} />
                        <Typography sx={{ fontSize: 12, fontWeight: 700 }}>Settled</Typography>
                      </Box>
                    )}

                    {isUnderReview && (
                      <Typography sx={{ fontSize: 11, color: "#d97706", fontWeight: 700, textAlign: "right" }}>
                        Awaiting restaurant
                        <br />confirmation ⏳
                      </Typography>
                    )}

                    {isActionable && (
                      <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.75}>
                        {settlementStatus === "REJECTED" && (
                          <Typography sx={{ fontSize: 10, color: "#dc2626", fontWeight: 700 }}>❌ Rejected — retry</Typography>
                        )}
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={<Payment sx={{ fontSize: 16 }} />}
                          onClick={() => handlePayToRestaurant(order._id)}
                          sx={{
                            borderRadius: 2, textTransform: "none", fontWeight: 700, fontSize: 11,
                            bgcolor: BRAND.primary, "&:hover": { bgcolor: BRAND.primaryDark },
                            boxShadow: "0 4px 12px rgba(255,107,0,0.25)",
                          }}
                        >
                          Pay Now
                        </Button>
                      </Box>
                    )}
                  </Box>
                </CardContent>
              </Card>
            );
          })}

          {myCodOrders.length === 0 && (
            <Box textAlign="center" py={10}>
              <Box sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                <AccountBalanceWallet sx={{ fontSize: 40, color: "#cbd5e1" }} />
              </Box>
              <Typography sx={{ fontWeight: 700, color: "#475569", mb: 0.5 }}>No COD orders</Typography>
              <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                Cash on delivery orders will appear here after delivery.
              </Typography>
            </Box>
          )}
        </Box>
      )}

      {/* ══════════════ TAB 3: PROFILE ══════════════ */}
      {navTab === 3 && (
        <Box p={2}>
          <Card elevation={0} sx={{ borderRadius: 3, mb: 2, overflow: "hidden", border: "1px solid #f1f5f9" }}>
            <Box sx={{ height: 80, background: BRAND.gradient, position: "relative" }} />
            <Box sx={{ px: 2, pb: 2, mt: -5, position: "relative" }}>
              <Box position="relative" display="inline-block">
                <Avatar
                  src={newProfileImage ? URL.createObjectURL(newProfileImage) : profile.profileImage?.url}
                  sx={{
                    width: 82, height: 82,
                    border: "4px solid #fff",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                    fontSize: 30, fontWeight: 800,
                    bgcolor: BRAND.primary,
                  }}
                >
                  {profile.name?.[0]?.toUpperCase()}
                </Avatar>
                <Box
                  component="label"
                  sx={{
                    position: "absolute", bottom: 2, right: 2,
                    width: 28, height: 28, borderRadius: "50%",
                    bgcolor: BRAND.primary, color: "#fff",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    border: "2px solid #fff", cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(255,107,0,0.4)",
                    transition: "all 0.2s",
                    "&:hover": { bgcolor: BRAND.primaryDark, transform: "scale(1.05)" },
                  }}
                >
                  <CameraAlt sx={{ fontSize: 14 }} />
                  <input type="file" accept="image/*" hidden onChange={(e) => setNewProfileImage(e.target.files[0])} />
                </Box>
              </Box>
              <Typography sx={{ fontSize: 17, fontWeight: 800, mt: 1.5, color: "#0f172a" }}>
                {profile.name || "Delivery Partner"}
              </Typography>
              <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                📍 {profile.city?.toUpperCase() || "N/A"} • {profile.phone || "N/A"}
              </Typography>
            </Box>
          </Card>

          <Card elevation={0} sx={{ borderRadius: 3, p: 2, mb: 2, border: "1px solid #f1f5f9" }}>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: "#FFF4EC", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Person sx={{ fontSize: 16, color: BRAND.primary }} />
              </Box>
              <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>Personal Info</Typography>
            </Box>

            <form onSubmit={handleSaveProfile}>
              <Stack spacing={1.5}>
                <TextField fullWidth size="small" label="Full Name" value={profileForm.name} onChange={(e) => setProfileForm({ ...profileForm, name: e.target.value })} sx={textFieldSx} />
                <TextField fullWidth size="small" label="Phone" value={profileForm.phone} onChange={(e) => setProfileForm({ ...profileForm, phone: e.target.value })} sx={textFieldSx} />
                <TextField fullWidth size="small" label="Assigned City" value={profile.city?.toUpperCase() || ""} disabled sx={textFieldSx} />
                <TextField fullWidth size="small" label="Vehicle Number" value={profileForm.vehicleNumber} onChange={(e) => setProfileForm({ ...profileForm, vehicleNumber: e.target.value })} sx={textFieldSx} />
                <TextField fullWidth size="small" multiline rows={2} label="Address" value={profileForm.address} onChange={(e) => setProfileForm({ ...profileForm, address: e.target.value })} sx={textFieldSx} />
                <Button
                  fullWidth type="submit" variant="contained" disabled={savingProfile}
                  sx={{
                    mt: 1, py: 1.1,
                    bgcolor: BRAND.primary, "&:hover": { bgcolor: BRAND.primaryDark },
                    fontWeight: 700, textTransform: "none", borderRadius: 2,
                    boxShadow: "0 4px 12px rgba(255,107,0,0.25)",
                  }}
                >
                  {savingProfile ? "Saving..." : "Save Details"}
                </Button>
              </Stack>
            </form>
          </Card>

          <Card elevation={0} sx={{ borderRadius: 3, p: 2, border: "1px solid #f1f5f9" }}>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Refresh sx={{ fontSize: 16, color: "#2563eb" }} />
              </Box>
              <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>Change Password</Typography>
            </Box>

            <form onSubmit={handleChangePassword}>
              <Stack spacing={1.5}>
                <TextField fullWidth size="small" label="Current Password" type="password" required value={passwordForm.currentPassword} onChange={(e) => setPasswordForm({ ...passwordForm, currentPassword: e.target.value })} sx={textFieldSx} />
                <TextField fullWidth size="small" label="New Password" type="password" required value={passwordForm.newPassword} onChange={(e) => setPasswordForm({ ...passwordForm, newPassword: e.target.value })} sx={textFieldSx} />
                <Button
                  fullWidth type="submit" variant="outlined"
                  sx={{
                    mt: 1, py: 1.1,
                    borderColor: BRAND.primary, color: BRAND.primaryDark,
                    fontWeight: 700, textTransform: "none", borderRadius: 2,
                    "&:hover": { borderColor: BRAND.primaryDark, bgcolor: "#FFF4EC" },
                  }}
                >
                  Update Password
                </Button>
              </Stack>
            </form>
          </Card>
        </Box>
      )}

      {/* ══════════════ ORDER DETAILS DIALOG ══════════════ */}
      <Dialog fullScreen open={detailsOpen} onClose={() => setDetailsOpen(false)} TransitionComponent={Transition}>
        <DialogTitle
          sx={{
            p: 2, display: "flex", justifyContent: "space-between", alignItems: "center",
            bgcolor: "#fff", borderBottom: "1px solid #f1f5f9", color: "#0f172a",
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box sx={{ width: 40, height: 40, borderRadius: 2, background: BRAND.gradient, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
              <Receipt sx={{ fontSize: 22 }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase" }}>Order</Typography>
              <Typography sx={{ fontSize: 15, fontWeight: 800, fontFamily: "monospace", lineHeight: 1.1 }}>
                #{selectedOrder?._id?.slice(-6).toUpperCase()}
              </Typography>
              <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.2 }}>{formatOrderDateTime(selectedOrder?.createdAt)}</Typography>
            </Box>
          </Box>
          <IconButton onClick={() => setDetailsOpen(false)} sx={{ bgcolor: "#f8fafc" }}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 2, bgcolor: "#f8fafc" }}>
          {selectedOrder && (
            <Box>
              <Card
                elevation={0}
                sx={{
                  p: 1.5, mb: 2, borderRadius: 2.5,
                  bgcolor: (ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).bg,
                  border: "1px solid",
                  borderColor: (ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).color + "40",
                }}
              >
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography sx={{ fontSize: 11, fontWeight: 800, color: (ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).color, letterSpacing: 0.5, textTransform: "uppercase" }}>
                    Current Status
                  </Typography>
                  <Chip
                    label={(ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).label}
                    size="small"
                    sx={{ bgcolor: "#fff", color: (ORDER_STATUS_CFG[selectedOrder.status] || ORDER_STATUS_CFG.PENDING).color, fontWeight: 800, fontSize: 10, height: 22 }}
                  />
                </Box>
              </Card>

              <Card elevation={0} sx={{ p: 2, mb: 2, borderRadius: 3, border: "1px solid #fed7aa", bgcolor: "#fff" }}>
                <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                  <Box sx={{ width: 32, height: 32, borderRadius: 2, bgcolor: "#fef3c7", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Storefront sx={{ fontSize: 18, color: "#d97706" }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#d97706", letterSpacing: 0.75, textTransform: "uppercase" }}>Pickup From</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}>
                      {selectedOrder.restaurant?.restaurantName}
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={{ fontSize: 12, color: "#64748b", mb: 0.5, lineHeight: 1.4 }}>
                  {selectedOrder.restaurant?.restaurantAddress || selectedOrder.restaurant?.address}
                </Typography>
                <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                  📞 {selectedOrder.restaurant?.mobile || selectedOrder.restaurant?.whatsappNumber || "N/A"}
                </Typography>
                <Box display="flex" gap={1} mt={1.5}>
                  {selectedOrder.restaurant?.mobile && (
                    <Button
                      fullWidth size="small" variant="outlined" startIcon={<Call sx={{ fontSize: 16 }} />}
                      href={`tel:${selectedOrder.restaurant.mobile}`}
                      sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, borderColor: "#d97706", color: "#d97706" }}
                    >
                      Call
                    </Button>
                  )}
                  <Button
                    fullWidth size="small" variant="outlined" startIcon={<Navigation sx={{ fontSize: 16 }} />}
                    href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(selectedOrder.restaurant?.restaurantAddress || "")}`}
                    target="_blank"
                    sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, borderColor: "#d97706", color: "#d97706" }}
                  >
                    Map
                  </Button>
                </Box>
              </Card>

              <Card elevation={0} sx={{ p: 2, mb: 2, borderRadius: 3, border: "1px solid #bfdbfe", bgcolor: "#fff" }}>
                <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                  <Box sx={{ width: 32, height: 32, borderRadius: 2, bgcolor: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Home sx={{ fontSize: 18, color: "#2563eb" }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: 9, fontWeight: 800, color: "#2563eb", letterSpacing: 0.75, textTransform: "uppercase" }}>Deliver To</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}>{selectedOrder.customer?.name}</Typography>
                  </Box>
                </Box>
                <Typography sx={{ fontSize: 12, color: "#64748b", mb: 0.5, lineHeight: 1.4 }}>
                  {selectedOrder.customer?.address || "No address provided"}
                </Typography>
                <Typography sx={{ fontSize: 12, color: "#64748b" }}>📞 {selectedOrder.customer?.phone || "N/A"}</Typography>
                <Box display="flex" gap={1} mt={1.5}>
                  <Button
                    fullWidth size="small" variant="contained" startIcon={<Call sx={{ fontSize: 16 }} />}
                    href={`tel:${selectedOrder.customer?.phone}`}
                    sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, bgcolor: "#2563eb", "&:hover": { bgcolor: "#1d4ed8" } }}
                  >
                    Call
                  </Button>
                  <Button
                    fullWidth size="small" variant="outlined" startIcon={<Navigation sx={{ fontSize: 16 }} />}
                    href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(selectedOrder.customer?.address || "")}`}
                    target="_blank"
                    sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, borderColor: "#2563eb", color: "#2563eb" }}
                  >
                    Map
                  </Button>
                </Box>
              </Card>

              <Card elevation={0} sx={{ p: 2, mb: 2, borderRadius: 3, border: "1px solid #f1f5f9", bgcolor: "#fff" }}>
                <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", mb: 1 }}>Order Items</Typography>
                {selectedOrder.items?.map((item, idx) => (
                  <Box key={idx} py={0.75} display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{item.itemName}</Typography>
                      <Typography sx={{ fontSize: 10.5, color: "#94a3b8" }}>Qty: {item.quantity} × ₹{item.price}</Typography>
                    </Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 800 }}>₹{item.total || item.price * item.quantity}</Typography>
                  </Box>
                ))}
                <Divider sx={{ my: 1.5 }} />
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Total</Typography>
                  <Typography sx={{ fontSize: 20, fontWeight: 800, color: BRAND.primaryDark }}>
                    ₹{selectedOrder.orderSummary?.totalAmount || 0}
                  </Typography>
                </Box>
              </Card>

              <Card
                elevation={0}
                sx={{
                  p: 2, mb: 2, borderRadius: 3,
                  bgcolor: selectedOrder.paymentMethod === "CASH" ? "#fef2f2" : "#f0fdf4",
                  border: "1px solid",
                  borderColor: selectedOrder.paymentMethod === "CASH" ? "#fecaca" : "#bbf7d0",
                }}
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Box sx={{ width: 32, height: 32, borderRadius: 2, bgcolor: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {selectedOrder.paymentMethod === "CASH"
                      ? <Warning sx={{ fontSize: 18, color: "#dc2626" }} />
                      : <CheckCircle sx={{ fontSize: 18, color: "#059669" }} />}
                  </Box>
                  <Box flex={1}>
                    <Typography sx={{ fontSize: 9, fontWeight: 800, color: selectedOrder.paymentMethod === "CASH" ? "#dc2626" : "#059669", letterSpacing: 0.75, textTransform: "uppercase" }}>
                      {selectedOrder.paymentMethod === "CASH" ? "Collect Cash" : "Payment Status"}
                    </Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: selectedOrder.paymentMethod === "CASH" ? "#dc2626" : "#059669" }}>
                      {selectedOrder.paymentMethod === "CASH"
                        ? `₹${selectedOrder.orderSummary?.totalAmount || 0} from customer`
                        : "Already paid online ✓"}
                    </Typography>
                  </Box>
                </Box>
              </Card>

              {/* 🆕 UPDATED STATUS DROPDOWN: Hotel-controlled (disabled) + Delivery boy-controlled (enabled) */}
              {isMyOrder(selectedOrder) && selectedOrder.status !== "DELIVERED" && (
                <Card elevation={0} sx={{ p: 2, mb: 2, borderRadius: 3, border: "1px solid #f1f5f9", bgcolor: "#fff" }}>
                  <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: 1.5,
                        bgcolor: "#FFF4EC",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Refresh sx={{ fontSize: 16, color: BRAND.primary }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#94a3b8", letterSpacing: 0.5, textTransform: "uppercase", lineHeight: 1 }}>
                        Update Delivery Status
                      </Typography>
                      <Typography sx={{ fontSize: 10.5, color: "#94a3b8", mt: 0.25 }}>
                        Hotel updates PENDING → ACCEPTED → PREPARING → COMPLETED
                      </Typography>
                    </Box>
                  </Box>

                  <FormControl fullWidth size="small">
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={selectedOrder.status}
                      label="Status"
                      onChange={(e) => handleUpdateStatus(selectedOrder._id, e.target.value)}
                      sx={{ borderRadius: 2, fontSize: 13 }}
                      MenuProps={{
                        PaperProps: { sx: { maxHeight: 340, borderRadius: 2 } },
                      }}
                    >
                      {/* ── HOTEL CONTROLLED (Disabled) ── */}
                      <MenuItem
                        value="PENDING"
                        disabled
                        sx={{ fontSize: 13, opacity: 0.55, fontStyle: "italic" }}
                      >
                        ⏳ PENDING (Updated by Hotel)
                      </MenuItem>
                      <MenuItem
                        value="ACCEPTED"
                        disabled
                        sx={{ fontSize: 13, opacity: 0.55, fontStyle: "italic" }}
                      >
                        ✅ ACCEPTED (Updated by Hotel)
                      </MenuItem>
                      <MenuItem
                        value="PREPARING"
                        disabled
                        sx={{ fontSize: 13, opacity: 0.55, fontStyle: "italic" }}
                      >
                        👨‍🍳 PREPARING (Updated by Hotel)
                      </MenuItem>
                      <MenuItem
                        value="COMPLETED"
                        disabled
                        sx={{ fontSize: 13, opacity: 0.55, fontStyle: "italic" }}
                      >
                        🍽️ COMPLETED / READY (Updated by Hotel)
                      </MenuItem>

                      <Divider sx={{ my: 0.5 }} />

                      {/* ── DELIVERY BOY CONTROLLED (Enabled) ── */}
                      <MenuItem
                        value="OUT_FOR_DELIVERY"
                        sx={{ fontSize: 13, fontWeight: 600, color: "#2563eb" }}
                      >
                        🛵 PICK UP / OUT FOR DELIVERY
                      </MenuItem>
                      <MenuItem
                        value="DELIVERED"
                        sx={{ fontSize: 13, fontWeight: 600, color: "#059669" }}
                      >
                        🎉 DELIVERED (Handed Over to Customer)
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <Typography
                    sx={{
                      fontSize: 10.5,
                      color: "#94a3b8",
                      mt: 1,
                      fontStyle: "italic",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 0.5,
                    }}
                  >
                    <Warning sx={{ fontSize: 12, mt: 0.15, flexShrink: 0 }} />
                    <span>
                      You can only mark <strong>Pick Up</strong> or <strong>Delivered</strong>. Other
                      statuses are managed by the restaurant.
                    </span>
                  </Typography>
                </Card>
              )}

              {!selectedOrder.deliveryBoy && (
                <Button
                  fullWidth variant="contained" size="large"
                  onClick={() => handleAcceptOrder(selectedOrder._id)}
                  sx={{
                    py: 1.5, fontWeight: 800, textTransform: "none", borderRadius: 2.5,
                    bgcolor: BRAND.primary, "&:hover": { bgcolor: BRAND.primaryDark },
                    boxShadow: "0 8px 20px rgba(255,107,0,0.35)", mb: 2,
                  }}
                >
                  Accept & Assign to Me
                </Button>
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* ══════════════ QR DIALOG ══════════════ */}
      <Dialog open={qrDialog.open} onClose={closeQRDialog} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ textAlign: "center", pb: 1, position: "relative" }}>
          <IconButton onClick={closeQRDialog} size="small" sx={{ position: "absolute", top: 8, right: 8, bgcolor: "#f8fafc" }}>
            <Close fontSize="small" />
          </IconButton>
          <Box
            sx={{
              width: 52, height: 52, borderRadius: "50%", mx: "auto", mb: 1,
              display: "flex", alignItems: "center", justifyContent: "center",
              background: qrDialog.type === "UPI"
                ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
                : "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
              color: "#fff",
            }}
          >
            <QrCode2 sx={{ fontSize: 28 }} />
          </Box>
          <Typography sx={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
            {qrDialog.type === "UPI" ? "UPI Payment" : "PhonePe Payment"}
          </Typography>
          <Typography sx={{ fontSize: 12, color: "#64748b", mt: 0.25 }}>{qrDialog.restaurant?.restaurantName}</Typography>
        </DialogTitle>

        <DialogContent sx={{ textAlign: "center", pb: 3 }}>
          {qrDialog.restaurant && getActiveUpiId() ? (
            <>
              <Box sx={{ p: 2, bgcolor: "#fff", borderRadius: 3, border: "2px dashed #e2e8f0", display: "inline-block", mb: 2, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
                <img
                  src={generateQRUrl(generateUPILink(getActiveUpiId(), qrDialog.restaurant.restaurantName))}
                  alt="QR Code"
                  style={{ width: 220, height: 220, display: "block" }}
                />
              </Box>

              <Box sx={{ bgcolor: "#f8fafc", borderRadius: 2, p: 1.5, mb: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                <Box textAlign="left" flex={1} minWidth={0}>
                  <Typography sx={{ fontSize: 10, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>UPI ID</Typography>
                  <Typography sx={{ fontSize: 13, fontWeight: 800, fontFamily: "monospace", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "#0f172a" }}>
                    {getActiveUpiId()}
                  </Typography>
                </Box>
                <IconButton size="small" onClick={handleCopyUpi} sx={{ bgcolor: "#FFF4EC", color: BRAND.primary, "&:hover": { bgcolor: "#FFE8D6" } }}>
                  <ContentCopy fontSize="small" />
                </IconButton>
              </Box>

              <Typography variant="caption" sx={{ color: "#94a3b8", display: "block", mb: 2, fontSize: 11 }}>
                Scan with GPay, PhonePe, Paytm or any UPI app
              </Typography>

              <Button
                fullWidth variant="contained" startIcon={<QrCode2 />}
                onClick={() => { window.location.href = generateUPILink(getActiveUpiId(), qrDialog.restaurant.restaurantName); }}
                sx={{
                  py: 1.2, fontWeight: 800, textTransform: "none", borderRadius: 2,
                  background: qrDialog.type === "UPI"
                    ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
                    : "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                  "&:hover": {
                    background: qrDialog.type === "UPI"
                      ? "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)"
                      : "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
                  },
                }}
              >
                Open in {qrDialog.type === "UPI" ? "UPI App" : "PhonePe"}
              </Button>
            </>
          ) : (
            <Box py={3}>
              <Typography variant="body2" color="text.secondary">Payment details not available for this restaurant.</Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* ══════════════ BOTTOM NAV ══════════════ */}
      <Paper
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0, maxWidth: 550, mx: "auto", zIndex: 1000, borderTop: "1px solid #f1f5f9", bgcolor: "#fff" }}
        elevation={0}
      >
        <BottomNavigation
          showLabels
          value={navTab}
          onChange={(e, val) => setNavTab(val)}
          sx={{
            height: 64, bgcolor: "#fff",
            "& .MuiBottomNavigationAction-root": { minWidth: 0, color: "#94a3b8", transition: "color 0.2s" },
            "& .Mui-selected": { color: `${BRAND.primary} !important` },
            "& .MuiBottomNavigationAction-label": { fontSize: 10, fontWeight: 600 },
            "& .MuiBottomNavigationAction-label.Mui-selected": { fontSize: 10, fontWeight: 800 },
          }}
        >
          <BottomNavigationAction
            label="Orders"
            icon={
              <Badge badgeContent={counts.MY_ORDERS} color="error" sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 16, minWidth: 16 } }}>
                <Moped />
              </Badge>
            }
          />
          <BottomNavigationAction label="Hotels" icon={<Storefront />} />
          <BottomNavigationAction
            label="Earnings"
            icon={
              <Badge
                badgeContent={myCodOrders.filter((o) => ["UNSETTLED", "REJECTED"].includes(o.codSettlement?.status || "UNSETTLED")).length}
                color="error"
                sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 16, minWidth: 16 } }}
              >
                <AccountBalanceWallet />
              </Badge>
            }
          />
          <BottomNavigationAction label="Profile" icon={<Person />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}

// 🎨 Shared TextField styles
const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2, bgcolor: "#f8fafc", transition: "all 0.2s", fontSize: 13,
    "&:hover": { bgcolor: "#fff" },
    "& fieldset": { borderColor: "#e2e8f0" },
    "&:hover fieldset": { borderColor: "#cbd5e1" },
    "&.Mui-focused": { bgcolor: "#fff" },
    "&.Mui-focused fieldset": { borderColor: BRAND.primary, borderWidth: 1.5 },
  },
  "& .MuiInputLabel-root": { fontSize: 13 },
  "& .MuiInputLabel-root.Mui-focused": { color: BRAND.primaryDark },
};